<template>
  <v-main>
    <p
      class="text-center mt-4 mb-n2 fonttitle"
      style="font-size: 32px !important"
    >
      Credenciamento - Registro de Indicação
      {{
        formData.resultadoFinalizarPasso4?.nrIndicacao
          ? `- ${this.formData.resultadoFinalizarPasso4?.nrIndicacao}`
          : this.formData.cdIndicacao
          ? `- ${this.formData.cdIndicacao}`
          : ''
      }}
    </p>
    <v-container
      style="max-width: 1260px;"
    >
      <v-row>
        <v-col class="pa-0">
          <v-stepper v-model="passoAtual" :key="componentKey">
            <v-stepper-header v-if="!isDocPendente">
              <v-stepper-step
                :complete="passoAtual > 1 && validStep1"
                :editable="true"
                step="1"
                :edit-icon="'$complete'"
                @click="validateStep(1)"
                :rules="[() => validStep1 || passoAtual <= 1]"
                >Endereço do Consultório<small v-if="!validStep1 && validou1"
                  >Exite(m) campo(s) inválido(s)</small
                ></v-stepper-step
              >
              <v-divider></v-divider>
              <v-stepper-step
                :complete="passoAtual > 2 && validStep2"
                :editable="true"
                step="2"
                :edit-icon="'$complete'"
                @click="validateStep(2)"
                :rules="[() => validStep2 || passoAtual <= 2]"
                >Dados do Consultório<small v-if="!validStep2"
                  >Exite(m) campo(s) inválido(s)</small
                ></v-stepper-step
              >
              <v-divider></v-divider>
              <v-stepper-step
                :complete="
                  passoAtual > 3 && validStep3 && isAtendimentoValido()
                "
                :editable="true"
                step="3"
                :edit-icon="'$complete'"
                @click="validateStep(3)"
                :rules="[
                  () =>
                    (validStep3 && isAtendimentoValido()) || passoAtual <= 3,
                ]"
                >Atendimento<small v-if="!validStep3 || !isAtendimentoValido()"
                  >Exite(m) campo(s) inválido(s)</small
                ></v-stepper-step
              >
              <v-divider></v-divider>
              <v-stepper-step
                :complete="
                  passoAtual > 4 && (isPJ ? validStep4PJ : validStep4PF)
                "
                :editable="true"
                step="4"
                :edit-icon="'$complete'"
                @click="validateStep(4)"
                :rules="[
                  () => (isPJ ? validStep4PJ : validStep4PF) || passoAtual <= 4,
                ]"
                >Dados do Dentista<small v-if="!validStep4PF || !validStep4PJ"
                  >Exite(m) campo(s) inválido(s)</small
                ></v-stepper-step
              >
              <v-divider v-if="isAtualizacao"></v-divider>
              <v-stepper-step
                :editable="true"
                step="5"
                :edit-icon="'$complete'"
                @click="validateStep(5)"
                :rules="[
                  () => (isPJ ? validStep5 : validStep5) || passoAtual <= 5,
                ]"
                v-if="isAtualizacao"
                >Dados Complementares<small v-if="!validStep5 || !validStep5"
                  >Exite(m) campo(s) inválido(s)</small
                ></v-stepper-step
              >
            </v-stepper-header>

            <v-stepper-items>
              <!-- ------------ PASSO 1 --------------- -->
              <v-stepper-content step="1" class="px-0">
                <v-form ref="form1" v-model="validStep1">
                  <v-text-field
                    outlined
                    v-model="formData.passo1.tipoDocumento"
                    v-show="false"
                  ></v-text-field>

                  <v-container class="pb-16">
                    <v-row>
                      <v-col md="12">
                        <p style="md-12" class="titulo-azul text-h5">
                          Dados do consultório
                        </p>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col md="4" sm="8" cols="12">
                        <v-text-field
                          outlined
                          v-model="formData.passo1.cep"
                          label="CEP"
                          :disabled="true"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col md="3" sm="3" cols="12">
                        <v-autocomplete
                          autocomplete="nope"
                          outlined
                          v-model="formData.passo1.tipoLogradouro"
                          :items="formData.passo1.listaTipoLogradouros"
                          :rules="[obrigatorio]"
                          label="*Tipo endereço"
                          item-text="nome"
                          item-value="codigo"
                          @input="fieldUpdate"
                        ></v-autocomplete>
                      </v-col>
                      <v-col md="7" sm="6" cols="12">
                        <v-text-field
                          outlined
                          v-model="formData.passo1.endereco"
                          label="*Endereço"
                          maxlength="50"
                          :rules="[obrigatorio]"
                          @blur="
                            formData.passo1.endereco = clearAndUpper(
                              formData.passo1.endereco
                            ).trim()
                          "
                          @input="
                            formData.passo1.endereco = clearAndUpper(
                              formData.passo1.endereco
                            )
                          "
                          @keydown="validarAcentos($event)"
                        >
                        </v-text-field>
                      </v-col>
                      <v-col md="2" sm="3" cols="12">
                        <v-text-field
                          outlined
                          v-model="formData.passo1.numero"
                          label="*Número"
                          @input="fieldUpdate"
                          :rules="[obrigatorio]"
                          v-mask="'##########'"
                          inputmode="numeric"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col md="5" sm="5" cols="12">
                        <v-text-field
                          outlined
                          v-model="formData.passo1.complemento"
                          label="Complemento"
                          maxlength="20"
                          @input="fieldUpdate"
                        ></v-text-field>
                      </v-col>
                      <v-col md="2" sm="2" cols="4">
                        <v-autocomplete
                          outlined
                          v-model="formData.passo1.estado"
                          @change="formData.passo1.cidade = null"
                          :items="listaEstados"
                          :disabled="true"
                          :rules="[obrigatorio]"
                          label="*Estado"
                          @input="fieldUpdate"
                        ></v-autocomplete>
                      </v-col>
                      <v-col md="5" sm="5" cols="8">
                        <v-autocomplete
                          outlined
                          v-model="formData.passo1.cidade"
                          :items="formData.passo1.listaCidades"
                          item-text="nome"
                          item-value="codigoCidade"
                          label="*Cidade"
                          :rules="[obrigatorio]"
                          :disabled="true"
                          @input="fieldUpdate"
                        ></v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col md="4" sm="6" cols="12">
                        <v-autocomplete
                          outlined
                          v-model="formData.passo1.bairro"
                          :items="formData.passo1.listaBairros"
                          item-text="nome"
                          item-value="codigo"
                          label="*Bairro"
                          :rules="[obrigatorio]"
                          @input="fieldUpdate"
                          :disabled="isAtualizacao"
                        ></v-autocomplete>
                      </v-col>
                      <v-col
                        md="8"
                        sm="12"
                        cols="12"
                        v-if="!(!isDimensionado && isPJ)"
                      >
                        <v-textarea
                          outlined
                          rows="1"
                          v-model="formData.passo1.pontoRef"
                          counter="150"
                          label="Ponto de referência"
                          @input="fieldUpdate"
                        ></v-textarea>
                      </v-col>
                    </v-row>
                    <v-row>
                      <!-- passo 5 -->
                      <v-col md="3" sm="12" cols="12" v-if="isAtualizacao">
                        <v-text-field
                          outlined
                          label="CNES"
                          maxlength="7"
                          v-model="formData.passo5.cnes"
                        />
                      </v-col>
                      <v-col md="3" sm="6" cols="12" v-if="!isAtualizacao">
                        <v-text-field
                          outlined
                          v-model="formData.passo1.alvaraFunc"
                          label="Alvará de funcionamento"
                          @input="fieldUpdate"
                          v-mask="'###############'"
                          inputmode="numeric"
                        ></v-text-field>
                      </v-col>
                      <v-col md="3" sm="12" cols="12" v-if="isAtualizacao">
                        <v-text-field
                          outlined
                          label="Inscrição Municipal"
                          maxlength="70"
                          v-model="formData.passo5.inscricaoMunicipal"
                        />
                      </v-col>
                      <v-col md="3" sm="6" cols="12" v-if="!isAtualizacao">
                        <v-text-field
                          outlined
                          v-model="formData.passo1.nrVigilanciaSanitaria"
                          label="Alvará da Vigilância Sanitária"
                          @input="fieldUpdate"
                          v-mask="'####################'"
                          inputmode="numeric"
                        ></v-text-field>
                      </v-col>
                      <v-col md="4" sm="6" cols="12" v-if="isPJ && isOculto">
                        <label>Optante pelo Simples nacional?</label>
                        <v-radio-group
                          v-model="formData.passo5.simplesNacional"
                          row
                        >
                          <v-radio label="Sim" value="S"></v-radio>
                          <v-radio label="Não" value="N"></v-radio>
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col md="12" sm="12" cols="12">
                        <v-text-field
                          outlined
                          v-model="formData.passo1.site"
                          label="Site ou Rede Social da Clínica"
                          @input="fieldUpdate"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col md="6" sm="12" cols="12">
                        <v-text-field
                          outlined
                          v-model="formData.passo1.email"
                          label="*E-mail clínica"
                          :rules="[obrigatorio, emailValido]"
                          @input="fieldUpdate"
                          :disabled="isAtualizacao"
                        ></v-text-field>
                      </v-col>
                      <v-col md="3" sm="6" cols="12">
                        <v-text-field
                          outlined
                          v-model="formData.passo1.telefone"
                          label="*Telefone"
                          v-mask="['(##) ####-####', '(##) #####-####']"
                          inputmode="numeric"
                          placeholder="(__) ____-____"
                          :rules="[obrigatorio, telefoneValido]"
                          @input="fieldUpdate"
                          :disabled="isAtualizacao"
                        ></v-text-field>
                      </v-col>
                      <v-col md="3" sm="6" cols="12">
                        <v-text-field
                          outlined
                          v-model="formData.passo1.celular"
                          label="*Celular"
                          v-mask="'(##) #####-####'"
                          inputmode="numeric"
                          placeholder="(__) _____-____"
                          :rules="[obrigatorio, telefoneValido]"
                          @input="fieldUpdate"
                          :disabled="isAtualizacao"
                        ></v-text-field>
                      </v-col>
                      <v-col md="3" sm="12" cols="12" class="pb-0">
                        <v-text-field
                          outlined
                          label="Whatsapp"
                          v-model="formData.passo1.whatsapp"
                          v-mask="'(##) #####-####'"
                          inputmode="numeric"
                          placeholder="(__) _____-____"
                          :rules="[telefoneValido]"
                          @input="fieldUpdate"
                          :disabled="isAtualizacao"
                        />
                      </v-col>
                      <v-col
                        md="6"
                        sm="6"
                        cols="12"
                        class="mt-md-2 py-0 mb-8"
                        style="margin-top: -16px"
                      >
                        <v-checkbox
                          v-model="formData.passo1.permitirWhats"
                          label="Permitir a divulgação para o beneficiário?"
                          color="primary"
                          @input="fieldUpdate"
                          hide-details
                          class="pt-md-4"
                          :disabled="isAtualizacao"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col md="12" cols="12" class="text-right">
                        <v-btn class="mr-2" color="azulOdonto" @click="next"
                          >Continuar</v-btn
                        >
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </v-stepper-content>

              <!-- ------------ PASSO 2 --------------- -->
              <v-stepper-content step="2" class="px-0">
                <v-form ref="form2" v-model="validStep2" lazy-validation>
                  <v-container>
                    <v-row>
                      <v-col md="12">
                        <p style="md-12" class="titulo-azul text-h5">
                          Estrutura do consultório
                        </p>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col md="4" sm="4" cols="12">
                        <v-select
                          outlined
                          v-model="formData.passo2.qtdSalas"
                          :items="listaQtdSalas"
                          @input="fieldUpdate"
                          :rules="isLogado ? [] : [obrigatorio]"
                          item-text="valor"
                          item-value="codigo"
                        >
                          <template v-slot:label
                            ><div>
                              {{ isLogado ? '' : '*' }}Quantidade de Salas
                            </div></template
                          >
                        </v-select>
                      </v-col>
                      <v-col md="4" sm="4" cols="12">
                        <v-select
                          outlined
                          v-model="formData.passo2.seLugares"
                          :items="listaQtdSalas"
                          :rules="isLogado ? [] : [obrigatorio]"
                          @input="fieldUpdate"
                          item-text="valor"
                          item-value="codigo"
                        >
                          <template v-slot:label
                            ><div>
                              {{ isLogado ? '' : '*' }}Sala de Espera - Lugares
                            </div></template
                          >
                        </v-select>
                      </v-col>
                      <v-col md="4" sm="4" cols="12">
                        <v-select
                          outlined
                          v-model="formData.passo2.ventilacao"
                          :items="listaVentilacao"
                          :rules="isLogado ? [] : [obrigatorio]"
                          label="*Ventilação"
                          @input="fieldUpdate"
                        >
                          <template v-slot:label
                            ><div>
                              {{ isLogado ? '' : '*' }}Ventilação
                            </div></template
                          >
                        </v-select>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col md="4" sm="4" cols="12">
                        <v-select
                          outlined
                          v-model="formData.passo2.tipoEscritorio"
                          :items="listaTipoEscritorio"
                          label="Escritório"
                          @input="fieldUpdate"
                          item-text="valor"
                          item-value="codigo"
                        ></v-select>
                      </v-col>
                      <v-col md="4" sm="4" cols="12">
                        <v-select
                          outlined
                          v-model="formData.passo2.tipoImovel"
                          :items="listaTipoImovel"
                          :rules="isLogado ? [] : [obrigatorio]"
                          @input="fieldUpdate"
                        >
                          <template v-slot:label
                            ><div>
                              {{ isLogado ? '' : '*' }}Tipo do Imóvel
                            </div></template
                          >
                        </v-select>
                      </v-col>
                      <v-col md="4" sm="4" cols="12">
                        <v-select
                          outlined
                          v-model="formData.passo2.estacionamento"
                          :items="listaEstacionamento"
                          label="Estacionamento"
                          @input="fieldUpdate"
                        ></v-select>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col md="12" sm="12" cols="12" class="py-0">
                        <label>Facilidades de Acesso</label>
                      </v-col>
                      <v-col md="2" sm="2" cols="6">
                        <v-checkbox
                          v-model="formData.passo2.faMetro"
                          label="Metrô"
                          color="primary"
                          @input="fieldUpdate"
                          hide-details
                        >
                          <template v-slot:label>
                            <i class="fas fa-subway"></i>&nbsp;Metrô
                          </template>
                        </v-checkbox>
                      </v-col>
                      <v-col md="2" sm="2" cols="6">
                        <v-checkbox
                          v-model="formData.passo2.faOnibus"
                          label="Ônibus"
                          color="primary"
                          @input="fieldUpdate"
                          hide-details
                        >
                          <template v-slot:label>
                            <i class="fas fa-bus"></i>&nbsp;Ônibus
                          </template>
                        </v-checkbox>
                      </v-col>
                      <v-col md="2" sm="2" cols="6">
                        <v-checkbox
                          v-model="formData.passo2.faTrem"
                          label="Trem"
                          color="primary"
                          @input="fieldUpdate"
                          hide-details
                        >
                          <template v-slot:label>
                            <i class="fas fa-train"></i>&nbsp;Trem
                          </template>
                        </v-checkbox>
                      </v-col>
                      <v-col md="2" sm="2" cols="6">
                        <v-checkbox
                          v-model="formData.passo2.faOutro"
                          @change="formData.passo2.faOutroDesc = null"
                          label="Outro"
                          color="primary"
                          @input="fieldUpdate"
                          hide-details
                        ></v-checkbox>
                      </v-col>
                      <v-col
                        md="4"
                        sm="4"
                        cols="12"
                        v-if="formData.passo2.faOutro"
                      >
                        <v-text-field
                          outlined
                          v-model="formData.passo2.faOutroDesc"
                          label=""
                          maxlength="20"
                          placeholder="Descreva o acesso..."
                          @input="fieldUpdate"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col md="12" sm="12" cols="12">
                        <label id="labelArquivos" for="arquivos"
                          >Imagens do consutório</label
                        >
                      </v-col>
                      <v-col md="12" sm="12" cols="12">
                        <vue-dropzone
                          ref="myVueDropzone"
                          id="drop1"
                          :options="dropOptions"
                          @vdropzone-removed-file="removedFile"
                          class="dropzone needsclick dz-clickable"
                          style="border: 2px solid #9e9e9e; border-radius: 4px"
                        ></vue-dropzone>
                      </v-col>
                      <!-- <v-col md="12" sm="12" cols="12">
                        <v-avatar
                          v-for="(imgConsult, i) in listaImagensRetorno"
                          :key="'IC' + i"
                          rounded
                          size="100"
                          color="lgrey"
                          class="ma-1"
                        >
                          <expandable-image
                            class="image"
                            :src="imgConsult.base64"
                            aspect-ratio="2"
                            :alt="'Imagem consultório'"
                            :title="imgConsult.filename"
                          ></expandable-image>
                        </v-avatar>
                      </v-col> -->
                      <v-col md="12" sm="12" cols="12">
                        <v-btn
                          v-if="
                            listaImagensRetorno &&
                            listaImagensRetorno.length > 0
                          "
                          class="mr-2"
                          @click="
                            abrirModalDocumentos(
                              listaImagensRetorno.map((q) => {
                                if (q.base64.includes('base64,')) {
                                  return q.base64;
                                } else {
                                  return `data:image/jpeg;base64,${q.base64}`;
                                }
                              })
                            )
                          "
                          color="success"
                          ><i class="fas fa-file-image"></i>&nbsp;Ver
                          documentos</v-btn
                        >
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col md="12" sm="12" cols="12">
                        <v-divider></v-divider>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col md="12">
                        <p style="md-12" class="titulo-azul text-h5">
                          Comodidades e Diferenciais
                        </p>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col md="12" sm="12" cols="12" class="py-0">
                        <label>Atende nos idiomas</label>
                      </v-col>
                      <v-col md="2" sm="2" cols="6">
                        <v-checkbox
                          v-model="formData.passo2.idiomaIngles"
                          label="Inglês"
                          color="primary"
                          @input="fieldUpdate"
                          hide-details
                        >
                          <template v-slot:label>
                            <flag iso="gb" />&nbsp;Inglês
                          </template>
                        </v-checkbox>
                      </v-col>
                      <v-col md="2" sm="2" cols="6">
                        <v-checkbox
                          v-model="formData.passo2.idiomaEspanhol"
                          label="Espanhol"
                          color="primary"
                          @input="fieldUpdate"
                          hide-details
                        >
                          <template v-slot:label>
                            <flag iso="es" />&nbsp;Espanhol
                          </template>
                        </v-checkbox>
                      </v-col>
                      <v-col md="2" sm="2" cols="6">
                        <v-checkbox
                          v-model="formData.passo2.idiomaFrances"
                          label="Francês"
                          color="primary"
                          @input="fieldUpdate"
                          hide-details
                        >
                          <template v-slot:label>
                            <flag iso="fr" />&nbsp;Francês
                          </template>
                        </v-checkbox>
                      </v-col>
                      <v-col md="2" sm="2" cols="6">
                        <v-checkbox
                          v-model="formData.passo2.idiomaJapones"
                          label="Japonês"
                          color="primary"
                          @input="fieldUpdate"
                          hide-details
                        >
                          <template v-slot:label>
                            <flag iso="jp" />&nbsp;Japonês
                          </template>
                        </v-checkbox>
                      </v-col>
                      <v-col md="2" sm="2" cols="6">
                        <v-checkbox
                          v-model="formData.passo2.idiomaItaliano"
                          label="Italiano"
                          color="primary"
                          @input="fieldUpdate"
                          hide-details
                        >
                          <template v-slot:label>
                            <flag iso="it" />&nbsp;Italiano
                          </template>
                        </v-checkbox>
                      </v-col>
                      <v-col md="2" sm="2" cols="6">
                        <v-checkbox
                          v-model="formData.passo2.idiomaAlemao"
                          label="Alemão"
                          color="primary"
                          @input="fieldUpdate"
                          hide-details
                        >
                          <template v-slot:label>
                            <flag iso="de" />&nbsp;Alemão
                          </template>
                        </v-checkbox>
                      </v-col>
                      <v-col md="2" sm="2" cols="6">
                        <v-checkbox
                          v-model="formData.passo2.idiomaOutro"
                          @change="formData.passo2.idiomaOutroDesc = ''"
                          label="Outros"
                          color="primary"
                          @input="fieldUpdate"
                          hide-details
                        ></v-checkbox>
                      </v-col>
                      <v-col
                        md="4"
                        sm="4"
                        cols="12"
                        v-if="formData.passo2.idiomaOutro"
                      >
                        <v-text-field
                          outlined
                          v-model="formData.passo2.idiomaOutroDesc"
                          label=""
                          maxlength="20"
                          placeholder="Descreva o idioma..."
                          @input="fieldUpdate"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col md="3" sm="3" cols="6">
                        <v-checkbox
                          v-model="formData.passo2.wifi"
                          label="Wi-Fi para pacientes"
                          color="primary"
                          @input="fieldUpdate"
                          hide-details
                        >
                          <template v-slot:label>
                            <i class="fas fa-wifi"></i>&nbsp;Wi-Fi para
                            pacientes
                          </template>
                        </v-checkbox>
                      </v-col>
                      <v-col md="3" sm="3" cols="6">
                        <v-checkbox
                          v-model="formData.passo2.tvACabo"
                          label="TV a Cabo"
                          color="primary"
                          @input="fieldUpdate"
                          hide-details
                        >
                          <template v-slot:label>
                            <i class="fas fa-tv"></i>&nbsp;TV a Cabo
                          </template>
                        </v-checkbox>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col md="12" sm="12" cols="12">
                        <v-divider></v-divider>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col md="12">
                        <p style="md-12" class="titulo-azul text-h5">
                          Acessibilidade física
                        </p>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col md="3" sm="3" cols="6">
                        <v-checkbox
                          v-model="formData.passo2.acessoCadeirante"
                          label="Acesso a Cadeirante"
                          color="primary"
                          @input="fieldUpdate"
                          hide-details
                        >
                          <template v-slot:label>
                            <i class="fas fa-wheelchair"></i>&nbsp;Acesso a
                            Cadeirante
                          </template>
                        </v-checkbox>
                      </v-col>
                      <v-col md="3" sm="3" cols="6">
                        <v-checkbox
                          v-model="formData.passo2.rampaAcesso"
                          label="Rampa de Acesso"
                          color="primary"
                          @input="fieldUpdate"
                          hide-details
                        ></v-checkbox>
                      </v-col>
                      <v-col md="2" sm="2" cols="6">
                        <v-checkbox
                          v-model="formData.passo2.corrimao"
                          label="Corrimão"
                          color="primary"
                          @input="fieldUpdate"
                          hide-details
                        ></v-checkbox>
                      </v-col>
                      <v-col md="4" sm="4" cols="12">
                        <v-checkbox
                          v-model="formData.passo2.faixaPortasVidro"
                          label="Faixa para identificação de portas de vidro"
                          color="primary"
                          @input="fieldUpdate"
                          hide-details
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col md="12" sm="12" cols="12">
                        <v-divider></v-divider>
                      </v-col>
                    </v-row>
                    <v-container v-show="isLogado">
                      <v-row>
                        <v-col md="12">
                          <p style="md-12" class="titulo-azul text-h5">
                            Modelo de Remuneração
                          </p>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col md="12" sm="12" cols="12">
                          <v-combobox
                            v-model="formData.passo2.modeloRemuneracao"
                            item-disabled="disabled"
                            outlined
                            :items="formData.passo2.listaModeloRemuneracao"
                            label="Modelos"
                            multiple
                            chips
                            @input="fieldUpdate"
                            item-text="valor"
                            item-value="codigo"
                            :disabled="isAtualizacao"
                          ></v-combobox>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col md="12" sm="12" cols="12">
                          <v-divider></v-divider>
                        </v-col>
                      </v-row>
                    </v-container>
                    <v-row>
                      <v-col md="12">
                        <p style="md-12" class="titulo-azul text-h5">
                          Equipamentos
                        </p>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col md="3" sm="6" cols="12">
                        <v-select
                          outlined
                          v-model="formData.passo2.conservacaoEquip"
                          :items="listaConservacaoEquip"
                          @input="fieldUpdate"
                          :rules="isLogado ? [] : [obrigatorio]"
                          item-text="valor"
                          item-value="codigo"
                        >
                          <template v-slot:label
                            ><div>
                              {{ isLogado ? '' : '*' }}Conservação do Equipo
                            </div></template
                          >
                        </v-select>
                      </v-col>
                      <v-col md="3" sm="6" cols="12">
                        <v-select
                          outlined
                          v-model="formData.passo2.raioX"
                          :items="listaRaioX"
                          label="*Raio-X"
                          :rules="[obrigatorio]"
                          @input="fieldUpdate"
                          item-text="valor"
                          item-value="codigo"
                          :disabled="isAtualizacao"
                        ></v-select>
                      </v-col>
                      <v-col
                        md="3"
                        sm="6"
                        cols="12"
                        v-if="formData.passo2.raioX === 'E'"
                      >
                        <v-text-field
                          outlined
                          v-model="formData.passo2.dataManutencao"
                          label="Data do Conserto"
                          type="date"
                          :rules="[obrigatorio, dataConsertoInvalida]"
                        ></v-text-field>
                      </v-col>
                      <v-col md="3" sm="6" cols="12">
                        <v-select
                          outlined
                          v-model="formData.passo2.camera"
                          :items="listaCamera"
                          label="Câmera"
                          @input="fieldUpdate"
                          item-text="valor"
                          item-value="codigo"
                        ></v-select>
                      </v-col>
                      <v-col md="3" sm="6" cols="12">
                        <v-select
                          outlined
                          v-model="formData.passo2.softwareGestao"
                          :items="listaSoftGestao"
                          label="Software de Gestão"
                          @input="fieldUpdate"
                          item-text="valor"
                          item-value="codigo"
                        ></v-select>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col md="12" sm="12" cols="12">
                        <v-combobox
                          v-model="formData.passo2.equipamentos"
                          outlined
                          :items="listaEquipamentos"
                          label="Equipamentos"
                          multiple
                          chips
                          @input="fieldUpdate"
                        ></v-combobox>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col md="12" cols="12" class="text-right">
                        <v-btn
                          class="mr-2"
                          color="secundary"
                          @click="passoAtual = 1"
                          >Voltar</v-btn
                        >
                        <v-btn class="mr-2" color="primary" @click="next"
                          >Continuar</v-btn
                        >
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </v-stepper-content>

              <!-- ------------ PASSO 3 --------------- -->
              <v-stepper-content step="3" class="px-0">
                <v-form ref="form3" v-model="validStep3" lazy-validation>
                  <v-container>
                    <v-row>
                      <v-col md="12">
                        <p style="md-12" class="titulo-azul text-h5">
                          Preencha as características de Atendimento
                        </p>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col md="3" sm="6" cols="12">
                        <label>Realiza atendimento hospitalar</label>
                        <v-radio-group
                          v-model="formData.passo3.atendimentoHospitalar"
                          row
                          @change="formData.passo3.hospital = null"
                        >
                          <v-radio label="Sim" value="S"></v-radio>
                          <v-radio label="Não" value="N"></v-radio>
                        </v-radio-group>
                      </v-col>
                      <v-col md="9" sm="6" cols="12">
                        <label>&nbsp;</label>
                        <v-text-field
                          outlined
                          v-model="formData.passo3.hospital"
                          v-if="formData.passo3.atendimentoHospitalar === 'S'"
                          label="Nome do hospital"
                          maxlength="100"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col md="12" cols="12">
                        <label>Dias e horários de atendimento</label>
                      </v-col>
                    </v-row>
                    <v-row
                      v-for="(atend, idx) in formData.passo3
                        .listaHorariosAtendimento"
                      :key="'B' + idx"
                    >
                      <v-col md="12" sm="12" cols="12">
                        <v-chip
                          v-if="validarCamposData(atend)"
                          class="ma-2"
                          color="red"
                          text-color="white"
                          ><i class="fas mr-2 fa-exclamation-triangle"></i>
                          Selecione o(s) dia(s) da semana</v-chip
                        >
                      </v-col>
                      <v-col md="2" sm="6" cols="6">
                        <v-text-field
                          outlined
                          v-model="atend.entrada"
                          :rules="getRulesHour(atend.saida, atend)"
                          label="Entrada"
                          placeholder="__:__"
                          @input="fieldUpdate"
                          v-mask="'##:##'"
                          inputmode="numeric"
                        ></v-text-field>
                      </v-col>
                      <v-col md="2" sm="6" cols="6">
                        <v-text-field
                          outlined
                          v-model="atend.saida"
                          :rules="getRulesHour(atend.entrada, atend)"
                          label="Saída"
                          placeholder="__:__"
                          @input="fieldUpdate"
                          v-mask="'##:##'"
                          inputmode="numeric"
                        ></v-text-field>
                      </v-col>
                      <v-col md="1" sm="2" cols="6">
                        <v-checkbox
                          v-model="atend.segunda"
                          label="Segunda"
                          color="primary"
                          @input="fieldUpdate"
                          hide-details
                        ></v-checkbox>
                      </v-col>
                      <v-col md="1" sm="2" cols="6">
                        <v-checkbox
                          v-model="atend.terca"
                          label="Terça"
                          color="primary"
                          @input="fieldUpdate"
                          hide-details
                        ></v-checkbox>
                      </v-col>
                      <v-col md="1" sm="2" cols="6">
                        <v-checkbox
                          v-model="atend.quarta"
                          label="Quarta"
                          color="primary"
                          @input="fieldUpdate"
                          hide-details
                        ></v-checkbox>
                      </v-col>
                      <v-col md="1" sm="2" cols="6">
                        <v-checkbox
                          v-model="atend.quinta"
                          label="Quinta"
                          color="primary"
                          @input="fieldUpdate"
                          hide-details
                        ></v-checkbox>
                      </v-col>
                      <v-col md="1" sm="2" cols="6">
                        <v-checkbox
                          v-model="atend.sexta"
                          label="Sexta"
                          color="primary"
                          @input="fieldUpdate"
                          hide-details
                        ></v-checkbox>
                      </v-col>
                      <v-col md="1" sm="2" cols="6">
                        <v-checkbox
                          v-model="atend.sabado"
                          label="Sábado"
                          color="primary"
                          @input="fieldUpdate"
                          hide-details
                        ></v-checkbox>
                      </v-col>
                      <v-col md="1" sm="2" cols="6">
                        <v-checkbox
                          v-model="atend.domingo"
                          label="Domingo"
                          color="primary"
                          @input="fieldUpdate"
                          hide-details
                        ></v-checkbox>
                      </v-col>
                      <v-col md="1" sm="2" cols="6" class="text-right">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-if="idx == 0"
                              class="mx-2"
                              fab
                              small
                              color="success"
                              @click="
                                formData.passo3.listaHorariosAtendimento.push(
                                  {}
                                )
                              "
                              v-bind="attrs"
                              v-on="on"
                              ><i class="fas fa-plus"></i
                            ></v-btn>
                            <v-btn
                              v-else
                              class="mx-2"
                              fab
                              small
                              color="error"
                              @click="
                                formData.passo3.listaHorariosAtendimento.splice(
                                  idx,
                                  1
                                )
                              "
                              v-bind="attrs"
                              v-on="on"
                              ><i class="far fa-trash-alt"></i
                            ></v-btn>
                          </template>
                          <span>{{
                            idx == 0
                              ? 'Adicionar outro horário'
                              : 'Remover horário'
                          }}</span>
                        </v-tooltip>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col md="12">
                        <v-container class="py-0 fill-height">
                          <p style="md-12" class="titulo-azul text-h5">
                            Especialidades atendidas
                          </p>
                          <v-spacer></v-spacer>
                          <v-btn
                            class="mx-2"
                            v-if="!isAtualizacao"
                            small
                            color="warning"
                            @click="(dialogAlterarEspec = true), autoSave()"
                            ><i class="fas fa-pencil-alt"></i>Alterar
                            especialidades</v-btn
                          >
                        </v-container>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col md="12" cols="12">
                        <v-simple-table fixed-header class="elevation-1">
                          <template v-slot:default>
                            <thead>
                              <tr>
                                <th id="idEspecialidades1">Especialidades</th>
                                <th id="idEspaco11"></th>
                                <th
                                  id="idGrauInstrucao1"
                                  v-if="
                                    formData.listaEspecialidades.find(
                                      (x) => x.valorSelecionado === 'E'
                                    )
                                  "
                                >
                                  Grau Instrução
                                </th>
                                <th id="idEspaco12" v-else></th>
                                <th
                                  id="idCertificado1"
                                  v-if="
                                    formData.listaEspecialidades.find(
                                      (x) => x.valorSelecionado === 'E'
                                    )
                                  "
                                >
                                  Certificado
                                </th>
                                <th id="idEspaco13" v-else></th>
                              </tr>
                            </thead>
                            <tbody
                              v-for="(espec, i) in formData.listaEspecialidades"
                              :key="'E' + i"
                            >
                              <tr>
                                <td>{{ espec.titulo }}</td>
                                <td>
                                  {{
                                    espec.valorSelecionado == 'AA'
                                      ? 'Área de atuação'
                                      : 'Especialista'
                                  }}
                                </td>
                                <td>
                                  {{
                                    espec.valorSelecionado == 'E'
                                      ? $const.listaGrauInstrucao.find(
                                          (x) =>
                                            x.codigo === espec.grauInstrucao
                                        ).valor
                                      : ''
                                  }}
                                </td>
                                <td>
                                  <v-avatar
                                    v-if="espec.certificado"
                                    rounded
                                    size="50"
                                    color="lgrey"
                                    class="ma-1"
                                  >
                                    <expandable-image
                                      class="image"
                                      :src="espec.certificado"
                                      aspect-ratio="2"
                                      :alt="'certificado'"
                                    ></expandable-image>
                                  </v-avatar>
                                </td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </v-col>
                    </v-row>

                    <!--INATIVAÇÃO FEITA PELA DEM0010349-->
                    <!--<v-row v-if="isAtualizacao">
                      <v-col md="12" cols="12" class="pb-0">
                        <label class="font-weight-bold"
                          >Solicitação de alteração de especialidade</label
                        >
                      </v-col>
                      <v-col class="py-0" md="12" cols="12">
                        <v-textarea
                          auto-grow
                          rows="2"
                          outlined
                          label="Caso deseje alterar a especialidade, area de atuação ou tipo de especialista mencionar neste campo:
                          "
                          value=""
                          v-model="formData.passo5.dsCompEspec"
                        />
                      </v-col>
                    </v-row>-->

                    <v-row>
                      <v-col md="12" cols="12" v-if="isAtualizacao">
                        <p>
                          <strong>Obs:</strong> As especialidades selecionadas
                          para atendimento, deverão ser mantidas em sua
                          integralidade, cabendo a Odontoprev reavaliar o
                          processo de credenciamento caso haja alterações.
                        </p>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col md="12">
                        <p style="md-12" class="titulo-azul text-h5">
                          Qualificações
                        </p>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col md="12" sm="12" cols="12">
                        <v-combobox
                          v-model="formData.passo3.qualificacoes"
                          outlined
                          :items="formData.passo3.listaQualificacoes"
                          item-text="valor"
                          item-value="codigo"
                          label="Qualificações"
                          multiple
                          chips
                          @input="fieldUpdate"
                        ></v-combobox>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col md="12" cols="12" class="text-right">
                        <v-btn
                          class="mr-2"
                          color="secundary"
                          @click="passoAtual = 2"
                          >Voltar</v-btn
                        >
                        <v-btn class="mr-2" color="primary" @click="next"
                          >Continuar</v-btn
                        >
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </v-stepper-content>

              <!-- ------------ PASSO 4 --------------- -->
              <v-stepper-content step="4" class="px-0">
                <v-container>
                  <v-row>
                    <v-col md="12">
                      <p style="md-12" class="text-h5 titulo-azul">
                        Preencha os dados cadastrais do Dentista
                        <v-chip class="ma-2" color="orange" text-color="white"
                          ><i class="fas mr-2 fa-exclamation-triangle"></i>
                          Importante: não abrevie os nomes</v-chip
                        >
                      </p>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col md="4" sm="6" cols="12">
                      <v-text-field
                        outlined
                        v-model="formData.passo1.documento"
                        :disabled="true"
                      >
                        <template v-slot:label
                          ><div>{{ isPJ ? 'CNPJ' : 'CPF' }}</div></template
                        >
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
                <v-container v-if="!isPJ">
                  <!-- Dados Pessoa Física -->
                  <v-form ref="form4PF" v-model="validStep4PF" lazy-validation>
                    <v-row>
                      <v-col md="6" sm="12" cols="12">
                        <v-text-field
                          outlined
                          v-model="formData.passo4.nomeDentista"
                          label="*Nome"
                          maxlength="70"
                          :rules="[obrigatorio, checaNomeAbreviado, letrasPf]"
                          @keyup="
                            formData.passo4.nomeDentista =
                              formData.passo4.nomeDentista.toUpperCase()
                          "
                          :disabled="isAtualizacao"
                        ></v-text-field>
                      </v-col>
                      <!--<v-col md="3" sm="6" cols="12">
                        <v-text-field
                          outlined
                          v-model="formData.passo4.cro"
                          label="*CRO/UF"
                          placeholder="CRO"
                          @input="fieldUpdate"
                          :rules="[obrigatorio, croValido, checkCroConsultorio]"
                          maxlength="10"
                          @keyup="
                            formData.passo4.cro =
                              formData.passo4.cro.toUpperCase()
                          "
                          :disabled="isAtualizacao"
                        ></v-text-field>
                      </v-col>-->

                      <v-col md="3" sm="6" cols="12">
                        <v-text-field
                          outlined
                          v-model="formData.passo4.croClinicaNumeroPf"
                          label="*CRO "
                          placeholder="CRO"
                          @input="onCroNumeroInput"
                          :rules="[obrigatorio]"
                          maxlength="7"
                          :disabled="isAtualizacao"
                        ></v-text-field>
                      </v-col>

                      <v-col md="3" sm="6" cols="12">
                        <v-select
                          outlined
                          v-model="formData.passo4.ufClinicaPf"
                          :items="listaEstados"
                          label="*UF do CRO"
                          item-text="nome"
                          item-value="sigla"
                          :rules="[obrigatorio, checkCroConsultorioEpao]"
                          :disabled="isAtualizacao"
                        ></v-select>
                      </v-col>

                      <v-col md="3" sm="6" cols="12" v-if="isDimensionado">
                        <v-text-field
                          outlined
                          v-model="formData.passo4.rg"
                          maxlength="18"
                          :rules="isLogado ? [] : [obrigatorio]"
                          @blur="
                            formData.passo4.rg = clearAndUpper(
                              formData.passo5.rg
                            ).trim()
                          "
                          @input="
                            formData.passo4.rg = clearAndUpper(
                              formData.passo5.rg
                            )
                          "
                          @keydown="validarAcentos($event)"
                        >
                          <template v-slot:label
                            ><div>{{ isLogado ? '' : '*' }}RG</div></template
                          >
                        </v-text-field>
                      </v-col>
                      <v-col md="3" sm="6" cols="12">
                        <v-text-field
                          outlined
                          v-model="formData.passo4.dataNasc"
                          prepend-inner-icon="event"
                          v-mask="'##/##/####'"
                          inputmode="numeric"
                          placeholder="__/__/____"
                          :rules="[
                            obrigatorio,
                            dataValida,
                            checaDataFormaturaIsValida,
                          ]"
                          :disabled="true"
                        >
                          <template v-slot:label
                            ><div>*Data de nascimento</div></template
                          >
                        </v-text-field>
                      </v-col>
                      <v-col md="6" sm="6" cols="12" v-if="isDimensionado">
                        <v-autocomplete
                          autocomplete="nope"
                          outlined
                          v-model="formData.passo4.paisNasc"
                          :items="listaPais"
                          :rules="isLogado ? [] : [obrigatorio]"
                          @change="
                            (formData.passo4.ufNasc = null),
                              (formData.passo4.cidadeNasc = null)
                          "
                          @input="fieldUpdate"
                          item-text="valor"
                          item-value="codigo"
                        >
                          <template v-slot:label
                            ><div>
                              {{ isLogado ? '' : '*' }}País de nascimento
                            </div></template
                          >
                        </v-autocomplete>
                      </v-col>
                      <v-col md="3" sm="5" cols="12" v-if="isDimensionado">
                        <v-autocomplete
                          autocomplete="nope"
                          outlined
                          v-model="formData.passo4.ufNasc"
                          :items="listaEstados"
                          :disabled="formData.passo4.paisNasc != 1"
                          @change="
                            buscarCidadesNasc(formData.passo4.ufNasc);
                            formData.passo4.cidadeNasc = null;
                          "
                          :rules="
                            checkCamposNascNaoObrigatorio ||
                            formData.passo4.paisNasc != 1
                              ? []
                              : [obrigatorio]
                          "
                          @input="fieldUpdate"
                        >
                          <template v-slot:label
                            ><div>
                              {{ checkCamposNascNaoObrigatorio ? '' : '*' }}UF
                              de nascimento
                            </div></template
                          >
                        </v-autocomplete>
                      </v-col>
                      <v-col md="3" sm="7" cols="12" v-if="isDimensionado">
                        <v-autocomplete
                          autocomplete="nope"
                          outlined
                          v-model="formData.passo4.cidadeNasc"
                          :disabled="formData.passo4.ufNasc == null"
                          :items="formData.passo4.listaCidadesNasc"
                          :rules="
                            checkCamposNascNaoObrigatorio ||
                            formData.passo4.paisNasc != 1
                              ? []
                              : [obrigatorio]
                          "
                          @input="fieldUpdate"
                          item-text="nome"
                          item-value="codigoCidade"
                        >
                          <template v-slot:label
                            ><div>
                              {{
                                checkCamposNascNaoObrigatorio ? '' : '*'
                              }}Município de nascimento
                            </div></template
                          >
                        </v-autocomplete>
                      </v-col>
                      <v-col md="3" sm="12" cols="12" v-if="isDimensionado">
                        <v-autocomplete
                          autocomplete="nope"
                          outlined
                          v-model="formData.passo4.nacionalidade"
                          :items="listaPais"
                          label="*Nacionalidade"
                          :rules="isLogado ? [] : [obrigatorio]"
                          @input="fieldUpdate"
                          item-text="valor"
                          item-value="valor"
                        >
                          <template v-slot:label
                            ><div>
                              {{ isLogado ? '' : '*' }}Nacionalidade
                            </div></template
                          >
                        </v-autocomplete>
                      </v-col>
                      <v-col md="3" sm="6" cols="12" v-if="isDimensionado">
                        <v-select
                          outlined
                          v-model="formData.passo4.racaCor"
                          :items="listaRacaCor"
                          :rules="isLogado ? [] : [obrigatorio]"
                          item-text="valor"
                          item-value="codigo"
                          @input="fieldUpdate"
                        >
                          <template v-slot:label
                            ><div>
                              {{ isLogado ? '' : '*' }}Raça/Cor
                            </div></template
                          >
                        </v-select>
                      </v-col>
                      <v-col md="3" sm="6" cols="12" v-if="isDimensionado">
                        <v-radio-group
                          v-model="formData.passo4.generoDentista"
                          mandatory
                          row
                          @change="fieldUpdate"
                        >
                          <v-radio label="Masculino" value="M"></v-radio>
                          <v-radio label="Feminino" value="F"></v-radio>
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col sm="6" cols="12">
                        <v-text-field
                          outlined
                          label="*Faculdade"
                          maxlength="70"
                          :rules="[obrigatorio]"
                          v-model="formData.passo4.faculdade"
                        />
                      </v-col>
                      <v-col md="3" sm="6" cols="12">
                        <v-select
                          outlined
                          return-object
                          v-model="formData.passo4.grauInstrucao"
                          label="Grau de Instrução"
                          :items="formData.passo4.listaGrauInstrucao"
                          item-text="nome"
                          item-value="codigo"
                        ></v-select>
                      </v-col>
                      <v-col md="3" sm="6" cols="12">
                        <v-text-field
                          outlined
                          v-model="formData.passo4.dataFormatura"
                          prepend-inner-icon="event"
                          :rules="[
                            obrigatorio,
                            dataValida,
                            checaDataFormaturaIsValida,
                          ]"
                          placeholder="__/__/____"
                          v-mask="'##/##/####'"
                          inputmode="numeric"
                        >
                          <template v-slot:label
                            ><div>*Data da formatura</div></template
                          >
                        </v-text-field>
                      </v-col>
                      <v-col md="3" sm="6" cols="12">
                        <v-text-field
                          outlined
                          v-model="formData.passo4.celular"
                          label="*Celular pessoal"
                          :rules="[obrigatorio, telefoneValido]"
                          v-mask="'(##) #####-####'"
                          placeholder="(__) _____-____"
                          @input="fieldUpdate"
                          inputmode="numeric"
                        ></v-text-field>
                      </v-col>
                      <v-col md="3" sm="6" cols="12">
                        <v-text-field
                          outlined
                          v-model="formData.passo4.telefone"
                          label="Telefone"
                          :rules="[telefoneValido]"
                          v-mask="'(##) ####-####'"
                          inputmode="numeric"
                          placeholder="(__) ____-____"
                          @input="fieldUpdate"
                        ></v-text-field>
                      </v-col>
                      <v-col md="4" sm="6" cols="12" v-if="isOculto">
                        <v-text-field
                          outlined
                          v-model="formData.passo4.emailClinica"
                          label="*E-mail clínica"
                          :rules="
                            isLogado
                              ? [emailValido]
                              : [obrigatorio, emailValido]
                          "
                          @input="fieldUpdate"
                        ></v-text-field>
                      </v-col>
                      <v-col md="6" sm="6" cols="12">
                        <v-text-field
                          outlined
                          v-model="formData.passo4.emailResponsavel"
                          :rules="
                            isLogado
                              ? [emailValido]
                              : [obrigatorio, emailValido]
                          "
                          @input="fieldUpdate"
                        >
                          <template v-slot:label
                            ><div>
                              {{ isLogado ? '' : '*' }}E-mail responsável
                            </div></template
                          >
                        </v-text-field>
                      </v-col>
                      <v-col sm="6" cols="12">
                        <label>Pessoa politicamente exposta</label>
                        <i
                          class="fas fa-question-circle"
                          style="
                            font-size: 18px;
                            cursor: pointer;
                            padding: 0 8px;
                            color: green;
                          "
                          @click="dialogPEP = true"
                        />
                        <v-radio-group v-model="formData.passo1.pep" row>
                          <v-radio label="Sim" value="S"></v-radio>
                          <v-radio label="Não" value="N"></v-radio>
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-row v-if="isDimensionado">
                      <v-col md="12" sm="12" cols="12">
                        <v-card class="mx-auto" outlined>
                          <v-card-text>
                            <v-row>
                              <v-col md="12" sm="12" cols="12">
                                <label style="md-12" class="titulo-azul text-h5"
                                  >Endereço residencial</label
                                >
                              </v-col>
                              <v-col cols="12" md="12" v-show="!!msgEndDent">
                                <v-alert
                                  style="cursor: pointer"
                                  @click="msgEndDent = ''"
                                  type="error"
                                >
                                  {{ msgEndDent }}
                                </v-alert>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col md="2" sm="3" cols="12">
                                <v-text-field
                                  outlined
                                  v-model="formData.passo4.erCep"
                                  @input="fieldUpdate"
                                  :rules="[]"
                                  @keyup="buscarCEP(formData.passo4.erCep, 0)"
                                  v-mask="'#####-###'"
                                  inputmode="numeric"
                                >
                                  <template v-slot:label
                                    ><div>CEP</div></template
                                  >
                                </v-text-field>
                              </v-col>
                              <v-col md="3" sm="3" cols="12">
                                <v-autocomplete
                                  autocomplete="nope"
                                  outlined
                                  v-model="formData.passo4.tipoLogradouro"
                                  :items="formData.passo1.listaTipoLogradouros"
                                  :rules="[]"
                                  item-text="nome"
                                  item-value="codigo"
                                  @input="fieldUpdate"
                                >
                                  <template v-slot:label
                                    ><div>Tipo endereço</div></template
                                  >
                                </v-autocomplete>
                              </v-col>
                              <v-col md="5" sm="6" cols="12">
                                <v-text-field
                                  outlined
                                  v-model="formData.passo4.erEndereco"
                                  maxlength="50"
                                  :rules="[]"
                                  @blur="
                                    formData.passo4.erEndereco = clearAndUpper(
                                      formData.passo4.erEndereco
                                    ).trim()
                                  "
                                  @input="
                                    formData.passo4.erEndereco = clearAndUpper(
                                      formData.passo4.erEndereco
                                    )
                                  "
                                  @keydown="validarAcentos($event)"
                                >
                                  <template v-slot:label
                                    ><div>Endereço</div></template
                                  >
                                </v-text-field>
                              </v-col>
                              <v-col md="2" sm="3" cols="12">
                                <v-text-field
                                  outlined
                                  v-model="formData.passo4.erNumero"
                                  @input="fieldUpdate"
                                  :rules="[]"
                                  v-mask="'##########'"
                                  inputmode="numeric"
                                >
                                  <template v-slot:label
                                    ><div>Número</div></template
                                  >
                                </v-text-field>
                              </v-col>
                              <v-col md="4" cols="8">
                                <v-text-field
                                  outlined
                                  v-model="formData.passo4.erComplemento"
                                  label="Complemento"
                                  maxlength="20"
                                  @input="fieldUpdate"
                                ></v-text-field>
                              </v-col>
                              <v-col md="2" sm="3" cols="4">
                                <v-select
                                  outlined
                                  v-model="formData.passo4.erEstado"
                                  :items="listaEstados"
                                  :rules="[]"
                                  @change="
                                    buscarCidades(formData.passo4.erEstado, 0);
                                    formData.passo4.erCidade = null;
                                  "
                                  :disabled="
                                    formData.passo4.desabilitarEndereco
                                  "
                                  @input="fieldUpdate"
                                >
                                  <template v-slot:label
                                    ><div>Estado</div></template
                                  >
                                </v-select>
                              </v-col>
                              <v-col md="5" sm="9" cols="8">
                                <v-select
                                  return-object
                                  outlined
                                  v-model="formData.passo4.erCidade"
                                  :items="formData.passo4.listaCidades"
                                  :rules="[]"
                                  :disabled="
                                    formData.passo4.desabilitarEndereco
                                  "
                                  @input="fieldUpdate"
                                  item-text="nome"
                                  item-value="codigoCidade"
                                >
                                  <template v-slot:label
                                    ><div>Cidade</div></template
                                  >
                                </v-select>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                    <v-row
                      v-if="isDimensionado"
                      d-flex
                      justify-center
                      align-center
                    >
                      <v-col md="5" sm="7" cols="12" class="py-0">
                        <v-text-field
                          outlined
                          v-model="formData.passo4.nrInscricao"
                          @input="fieldUpdate"
                          :rules="
                            isLogado
                              ? [checaInssIsValido]
                              : [obrigatorio, checaInssIsValido]
                          "
                          v-mask="'###########'"
                          inputmode="numeric"
                        >
                          <template v-slot:label
                            ><div>
                              {{ isLogado ? '' : '*' }}Número de Inscrição
                              Social (NIT/PIS/PASEP/INSS)
                            </div></template
                          >
                        </v-text-field>
                      </v-col>
                      <v-col md="6" sm="4" cols="12" class="pt-0">
                        <p class="ma-0">
                          para cadastrar o INSS
                          <a
                            target="_blank"
                            href="http://cnis.inss.gov.br/cnisinternet/faces/pages/index.xhtml"
                            id="cliqueAqui"
                            >clique aqui</a
                          >
                        </p>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-container>
                <v-container v-if="isPJ">
                  <!-- Dados Pessoa Jurídica -->
                  <v-form ref="form4PJ" v-model="validStep4PJ" lazy-validation>
                    <v-row>
                      <v-col md="5" sm="6" cols="12">
                        <v-text-field
                          outlined
                          v-model="formData.passo4.clinica"
                          label="*Nome da clínica"
                          maxlength="45"
                          :rules="[obrigatorio, letrasPj]"
                          @blur="
                            formData.passo4.clinica = Upper(
                              formData.passo4.clinica
                            ).trim()
                          "
                          @input="
                            formData.passo4.clinica = Upper(
                              formData.passo4.clinica
                            )
                          "
                          :disabled="isAtualizacao"
                        >
                        </v-text-field>
                      </v-col>
                      <v-col md="4" sm="6" cols="12" v-if="isDimensionado">
                        <v-text-field
                          outlined
                          v-model="formData.passo4.nomeFantasia"
                          maxlength="70"
                          :rules="isLogado ? [letrasPj] : [letrasPj, obrigatorio]"
                          @blur="
                            formData.passo4.nomeFantasia = Upper(
                              formData.passo4.nomeFantasia
                            ).trim()
                          "
                          @input="
                            formData.passo4.nomeFantasia = Upper(
                              formData.passo4.nomeFantasia
                            )
                          "
                        >
                          <template v-slot:label
                            ><div>
                              {{ isLogado ? '' : '*' }}Nome fantasia
                            </div></template
                          >
                        </v-text-field>
                      </v-col>
                      <!-- <v-col md="3" sm="6" cols="12">
                        <v-text-field
                          outlined
                          :value="formData.passo4.croClinica"
                          label="*CRO/UF da Clínica"
                          placeholder="EPAO-12345678912"
                          @input="onCroInput"
                          @keydown.native="blockPrefixDelete"
                          :rules="[obrigatorio, checkCroConsultorio]"
                          maxlength="20"
                          :disabled="isAtualizacao"
                        ></v-text-field>
                      </v-col> -->

                      <v-col md="3" sm="6" cols="12">
                        <v-text-field
                          outlined
                          v-model="formData.passo4.croClinicaNumero"
                          label="*CRO da Clínica"
                          placeholder="EPAO-12345678912"
                          @input="onCroInput"
                          @keydown.native="blockPrefixDelete"
                          :rules="[obrigatorio]"
                          maxlength="17"
                          :disabled="isAtualizacao"
                        ></v-text-field>
                      </v-col>
                      
                      <v-col md="3" sm="6" cols="12">
                        <v-select
                          outlined
                          v-model="formData.passo4.ufClinica"
                          :items="listaEstados"
                          label="*UF do CRO"
                          item-text="nome"
                          item-value="sigla"
                          :rules="[obrigatorio, checkCroConsultorioEpao]"
                          :disabled="isAtualizacao"
                        ></v-select>
                      </v-col>
                    </v-row>

                    <!-- Responsáveis Tecnicos -->
                    <v-container class="ma-0 pa-0">
                      <v-row v-for="(respTec, idx) in formData.passo4.listaRespTec" :key="idx">
                        <v-col md="12" sm="12" cols="12">
                          <v-card class="mx-auto" outlined>
                            <v-card-text>
                              <v-row>
                                <v-col md="11" sm="10" cols="9">
                                  <label style="md-12" class="titulo-azul text-h5">
                                    Dados Responsável Técnico {{ idx + 1 }}
                                  </label>
                                </v-col>

                                <v-col md="1" sm="2" cols="3" v-if="idx != 0">
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn
                                        class="mx-2"
                                        fab
                                        small
                                        color="error"
                                        @click="formData.passo4.listaRespTec.splice(idx, 1)"
                                        v-bind="attrs"
                                        v-on="on"
                                      >
                                        <i class="far fa-trash-alt"></i>
                                      </v-btn>
                                    </template>
                                    <span>Excluir responsável técnico</span>
                                  </v-tooltip>
                                </v-col>

                                <!-- Código do responsável -->
                                <v-text-field v-model="respTec.codigo" v-show="false"></v-text-field>

                                <v-col md="6" sm="6" cols="12">
                                  <v-text-field
                                    outlined
                                    v-model="respTec.nome"
                                    label="*Nome"
                                    maxlength="70"
                                    :rules="[obrigatorio, checaNomeAbreviado]"
                                    @blur="respTec.nome = clearAndUpper(respTec.nome).trim()"
                                    @input="respTec.nome = clearAndUpper(respTec.nome)"
                                    @keydown="validarAcentos($event)"
                                    :disabled="idx === 0 && isAtualizacao"
                                  />
                                </v-col>

                                <!-- CPF -->
                                <v-col md="3" sm="6" cols="12">
                                  <v-text-field
                                    outlined
                                    v-model="respTec.nrCpf"
                                    :counter="14"
                                    v-mask="'###.###.###-##'"
                                    inputmode="numeric"
                                    label="*CPF"
                                    :rules="[obrigatorio, regrasCpf]"
                                    :disabled="idx === 0 && isAtualizacao"
                                  />
                                </v-col>

                                <!-- RG -->
                                <v-col md="3" sm="6" cols="12" v-if="isDimensionado">
                                  <v-text-field
                                    outlined
                                    v-model="respTec.rg"
                                    maxlength="18"
                                    :rules="isLogado ? [] : [obrigatorio]"
                                  >
                                    <template v-slot:label>
                                      <div>{{ isLogado ? '' : '*' }}RG</div>
                                    </template>
                                  </v-text-field>
                                </v-col>

                                <!-- Data Nascimento -->
                                <v-col md="3" sm="6" cols="12">
                                  <v-text-field
                                    outlined
                                    v-model="respTec.dataNasc"
                                    prepend-inner-icon="event"
                                    v-mask="'##/##/####'"
                                    inputmode="numeric"
                                    placeholder="__/__/____"
                                    :rules="isLogado ? [] : [obrigatorio]"
                                    :disabled="idx === 0"
                                  >
                                    <template v-slot:label>
                                      <div>{{ isLogado ? '' : '*' }}Data de nascimento</div>
                                    </template>
                                  </v-text-field>
                                </v-col>

                                <!-- CRO -->
                                <v-col md="3" sm="6" cols="12">
                                  <v-text-field
                                    outlined
                                    v-model="respTec.cro"
                                    label="*CRO Responsável Técnico"
                                    placeholder="CRO"
                                    @input="validaCRORespTec"
                                    :rules="[obrigatorio]"
                                    maxlength="7"
                                    :disabled="idx === 0 && isAtualizacao"
                                  />
                                </v-col>

                                <!-- UF -->
                                <v-col md="3" sm="6" cols="12">
                                  <v-select
                                    outlined
                                    v-model="respTec.uf"
                                    :items="listaEstados"
                                    label="*UF do CRO"
                                    item-text="nome"
                                    item-value="sigla"
                                    :rules="[obrigatorio, checkCroConsultorioEpao]"
                                    :disabled="idx === 0 && isAtualizacao"
                                  />
                                </v-col>

                                <!-- Telefone -->
                                <v-col md="3" sm="6" cols="12">
                                  <v-text-field
                                    outlined
                                    v-model="respTec.telefone"
                                    label="Telefone"
                                    :rules="[telefoneValido]"
                                    v-mask="'(##) ####-####'"
                                    inputmode="numeric"
                                    placeholder="(__) ____-____"
                                    @input="fieldUpdate"
                                    :disabled="idx === 0 && isAtualizacao"
                                  />
                                </v-col>

                                <!-- Celular -->
                                <v-col md="3" sm="6" cols="12">
                                  <v-text-field
                                    outlined
                                    v-model="respTec.celular"
                                    v-mask="'(##) #####-####'"
                                    inputmode="numeric"
                                    placeholder="(__) _____-____"
                                    :rules="[obrigatorio, telefoneValido]"
                                    @input="fieldUpdate"
                                    :disabled="idx === 0 && isAtualizacao"
                                  >
                                    <template v-slot:label>
                                      <div>*Celular</div>
                                    </template>
                                  </v-text-field>
                                </v-col>

                                <!-- Faculdade -->
                                <v-col md="6" sm="6" cols="12">
                                  <v-text-field
                                    outlined
                                    label="*Faculdade"
                                    maxlength="70"
                                    :rules="[obrigatorio]"
                                    v-model="respTec.faculdade"
                                  />
                                </v-col>

                                <!-- Grau de Instrução -->
                                <v-col md="3" sm="6" cols="12">
                                  <v-select
                                    outlined
                                    return-object
                                    v-model="respTec.grauInstrucao"
                                    label="Grau de Instrução"
                                    :items="formData.passo4.listaGrauInstrucao"
                                    item-text="nome"
                                    item-value="codigo"
                                  />
                                </v-col>

                                <!-- Data Formatura -->
                                <v-col md="3" sm="6" cols="12">
                                  <v-text-field
                                    outlined
                                    v-model="respTec.dataFormatura"
                                    prepend-inner-icon="event"
                                    :rules="[obrigatorio, dataValida]"
                                    placeholder="__/__/____"
                                    v-mask="'##/##/####'"
                                    inputmode="numeric"
                                    :disabled="idx === 0 && isAtualizacao"
                                  >
                                    <template v-slot:label>
                                      <div>*Data da formatura</div>
                                    </template>
                                  </v-text-field>
                                </v-col>

                                <!-- Email -->
                                <v-col md="6" sm="6" cols="12">
                                  <v-text-field
                                    outlined
                                    v-model="respTec.email"
                                    label="*E-mail"
                                    :rules="[obrigatorio, emailValido]"
                                    @input="fieldUpdate"
                                  />
                                </v-col>

                                <!-- Sexo -->
                                <v-col md="6" sm="6" cols="12">
                                  <label>Sexo</label>
                                  <v-radio-group v-model="respTec.sexo" row>
                                    <v-radio label="Masculino" value="M" />
                                    <v-radio label="Feminino" value="F" />
                                  </v-radio-group>
                                </v-col>

                                <!-- PEP -->
                                <v-col md="6" sm="6" cols="12" v-if="isAtualizacao">
                                  <label>Pessoa politicamente exposta</label>
                                  <i
                                    class="fas fa-question-circle"
                                    style="font-size: 18px; cursor: pointer; padding: 0 8px; color: green;"
                                    @click="dialogPEP = true"
                                  />
                                  <v-radio-group v-model="respTec.pep" row>
                                    <v-radio label="Sim" value="S" />
                                    <v-radio label="Não" value="N" />
                                  </v-radio-group>
                                </v-col>
                              </v-row>

                              <!-- Endereço -->
                              <v-row v-if="isDimensionado && idx === 0">
                                <v-col md="12" sm="12" cols="12">
                                  <v-card class="mx-auto" outlined>
                                    <v-card-text>
                                      <!-- aqui segue igual ao seu código do endereço -->
                                    </v-card-text>
                                  </v-card>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>

                      <!-- Botão adicionar -->
                      <v-row v-if="formData.passo4.listaRespTec.length <= 2">
                        <v-col md="12" cols="12">
                          <v-btn class="mr-2" @click="addRespTec" color="success">
                            <i class="fas fa-user-plus"></i>&nbsp;Adicionar outro responsável
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-container>


                    <v-row>
                      <v-col md="12" sm="12" cols="12">
                        <v-divider></v-divider>
                      </v-col>
                    </v-row>

                    <!-- Representantes Legais -->
                    <v-container class="ma-0 pa-0">
                      <v-row
                        v-for="(repreLegal, idx) in formData.passo4
                          .listaRepreLegal"
                        :key="'A' + idx"
                      >
                        <v-col md="12" sm="12" cols="12">
                          <v-card class="mx-auto" outlined>
                            <v-card-text>
                              <v-row>
                                <v-col md="11" sm="10" cols="9">
                                  <label
                                    style="md-12"
                                    class="titulo-azul text-h5"
                                    >Dados Representante Legal
                                    {{ idx + 1 }}</label
                                  >
                                </v-col>
                                <v-col md="1" sm="2" cols="3" v-if="idx != 0">
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn
                                        class="mx-2"
                                        fab
                                        small
                                        color="error"
                                        @click="
                                          formData.passo4.listaRepreLegal.splice(
                                            idx,
                                            1
                                          )
                                        "
                                        v-bind="attrs"
                                        v-on="on"
                                        ><i class="far fa-trash-alt"></i
                                      ></v-btn>
                                    </template>
                                    <span>Excluir representante legal</span>
                                  </v-tooltip>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-text-field
                                  v-model="repreLegal.codigo"
                                  v-show="false"
                                ></v-text-field>
                                <v-col md="8" sm="6" cols="12">
                                  <v-text-field
                                    outlined
                                    v-model="repreLegal.nome"
                                    maxlength="70"
                                    :rules="
                                      isLogado
                                        ? [checaNomeAbreviado]
                                        : [obrigatorio, checaNomeAbreviado]
                                    "
                                    @blur="
                                      repreLegal.nome = clearAndUpper(
                                        repreLegal.nome
                                      ).trim()
                                    "
                                    @input="
                                      repreLegal.nome = clearAndUpper(
                                        repreLegal.nome
                                      )
                                    "
                                    @keydown="validarAcentos($event)"
                                    :disabled="nomeBloqueado"
                                  >
                                    <template v-slot:label
                                      ><div>
                                        {{ isLogado ? '' : '*' }}Nome
                                      </div></template
                                    >
                                  </v-text-field>
                                </v-col>
                                <v-col md="4" sm="6" cols="12">
                                  <label>Sexo</label>
                                  <v-radio-group
                                    v-model="repreLegal.sexo"
                                    row
                                    :rules="isLogado ? [] : [obrigatorio]"
                                    :disabled="sexoBloqueado"
                                  >
                                    <v-radio label="Masculino" value="M" />
                                    <v-radio label="Feminino" value="F" />
                                  </v-radio-group>
                                </v-col>
                                <v-col md="4" sm="6" cols="12">
                                  <v-text-field
                                    outlined
                                    v-model="repreLegal.nrCpf"
                                    :counter="14"
                                    v-mask="'###.###.###-##'"
                                    inputmode="numeric"
                                    label="CPF"
                                    :rules="
                                      isLogado
                                        ? [regrasCpf]
                                        : [obrigatorio, regrasCpf]
                                    "
                                    :disabled="nrCpfBloqueado"
                                  ></v-text-field>
                                </v-col>
                                <v-col md="4" sm="6" cols="12">
                                  <v-text-field
                                    outlined
                                    v-model="repreLegal.rg"
                                    label="RG"
                                    maxlength="18"
                                    :rules="isLogado ? [] : [obrigatorio]"
                                    :disabled="rgBloqueado"
                                  ></v-text-field>
                                </v-col>
                                <v-col md="3" sm="6" cols="12">
                                  <v-text-field
                                    outlined
                                    v-model="repreLegal.dataNasc"
                                    prepend-inner-icon="event"
                                    label="Data de nascimento"
                                    v-mask="'##/##/####'"
                                    inputmode="numeric"
                                    placeholder="__/__/____"
                                    :rules="
                                      isLogado
                                        ? [dataValida]
                                        : [obrigatorio, dataValida]
                                    "
                                    :disabled="dataNascBloqueado"
                                  ></v-text-field>
                                </v-col>
                                <v-col md="6" sm="6" cols="12">
                                  <v-text-field
                                    outlined
                                    v-model="repreLegal.email"
                                    label="*E-mail"
                                    :rules="
                                      isLogado
                                        ? [emailValido]
                                        : [emailValido, obrigatorio]
                                    "
                                    @input="fieldUpdate"
                                    :disabled="emailBloqueado"
                                  ></v-text-field>
                                </v-col>
                                <v-col
                                  md="3"
                                  sm="6"
                                  cols="12"
                                  v-if="isAtualizacao"
                                >
                                  <label>Pessoa politicamente exposta</label>
                                  <i
                                    class="fas fa-question-circle"
                                    style="
                                      font-size: 18px;
                                      cursor: pointer;
                                      padding: 0 8px;
                                      color: green;
                                    "
                                    @click="dialogPEP = true"
                                  />
                                  <v-radio-group v-model="repreLegal.pep" row>
                                    <v-radio label="Sim" value="S"></v-radio>
                                    <v-radio label="Não" value="N"></v-radio>
                                  </v-radio-group>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                      <v-row v-if="formData.passo4.listaRepreLegal.length <= 2">
                        <v-col md="12" cols="12">
                          <v-btn
                            class="mr-2"
                            @click="
                              formData.passo4.listaRepreLegal.push({ nome: '' })
                            "
                            color="success"
                            ><i class="fas fa-user-plus"></i>&nbsp;Adicionar
                            outro representante</v-btn
                          >
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-form>
                </v-container>
                <v-container>
                  <v-row>
                    <v-col cols="12" md="12" v-show="!!mensagem">
                      <v-alert
                        style="cursor: pointer"
                        @click="mensagem = ''"
                        type="error"
                      >
                        {{ mensagem }}
                      </v-alert>
                    </v-col>
                    <v-col md="12" cols="12" class="text-right">
                      <v-btn
                        class="mr-2"
                        color="secundary"
                        @click="passoAtual = 3"
                        >Voltar</v-btn
                      >
                      <v-btn class="mr-2" color="primary" @click="next">{{
                        isAtualizacao
                          ? 'Continuar'
                          : isLogado
                          ? 'Salvar'
                          : 'Finalizar'
                      }}</v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-stepper-content>

              <!-- ------------ PASSO 5 --------------- -->
              <v-stepper-content step="5" v-if="isAtualizacao" class="px-0">
                <v-form ref="form5" v-model="validStep5">
                  <v-container>
                    <v-row v-if="!isDocPendente">
                      <v-col md="12">
                        <p style="md-12" class="titulo-azul font-weight-black">
                          Venha sorrir com a gente!
                        </p>
                        <p style="md-12">
                          Falta pouco para concluir o seu processo de
                          credenciamento. Preencha todos os campos necessários e
                          inclua os documentos obrigatórios. Importante, em caso
                          de dúvidas sobre as regras operacionais, remuneração
                          de valores ou documentações entre em contato conosco
                          através dos nossos canais de atendimento:
                        </p>
                        <p>
                          Portal:
                          <a href="https://www.odontoprev.com.br/dentista"
                            >https://www.odontoprev.com.br/dentista</a
                          >
                        </p>
                        <p>
                          E-mail:
                          <a
                            :href="
                              'mailto:credenciamento@odontoprev.com.br?subject=Processo de credenciamento - Indicação: ' +
                              this.formData.cdIndicacao
                            "
                            >credenciamento@odontoprev.com.br</a
                          >
                        </p>
                      </v-col>
                      <v-col md="12">
                        <p style="md-12" class="titulo-azul text-h5">
                          Preencha os dados bancários:
                        </p>
                        <p style="md-12">
                          Conta Corrente Pessoa Física (não pode ser conta
                          poupança). <br />
                          <strong>Obs:</strong>Se conta corrente
                          <strong>CONJUNTA</strong>, o credenciado deve ser o
                          titular desta conta.
                        </p>
                      </v-col>
                      <v-col md="8" sm="8" cols="12">
                        <v-checkbox
                          class="ma-0"
                          v-model="formData.passo5.semDadosBancarios"
                          label="Caso não localize seu banco e/ou agencia na lista, clique aqui"
                          color="primary"
                          @input="fieldUpdate"
                          @change="
                            formData.passo5.banco = null;
                            formData.passo5.nrAgencia = null;
                            formData.passo5.nrAgenciaDig = null;
                            formData.passo5.nrConta = null;
                            formData.passo5.nrContaDig = null;
                            formData.passo5.docBancario = null;
                          "
                          hide-details
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        style="padding: 0 12px"
                        v-if="formData.passo5.semDadosBancarios"
                      >
                        <label
                          class="titulo-azul"
                          style="font-size: 12px; padding: 0"
                        >
                          <strong
                            >Adicionar comprovante com os dados bancários
                            contendo as seguintes informações (Número do Banco /
                            Nome do Banco / Agencia / Conta Corrente / Digito)
                          </strong></label
                        >
                      </v-col>
                      <template v-if="!formData.passo5.semDadosBancarios">
                        <v-col md="12" sm="12" cols="12">
                          <v-autocomplete
                            autocomplete="nope"
                            outlined
                            v-model="formData.passo5.banco"
                            :items="formData.passo5.listaBancos"
                            @input="fieldUpdate"
                            :rules="[
                              !isLogado ? obrigatorio : null,
                              !isLogado
                                ? (v) =>
                                    formData.passo5.listaBancos.some(
                                      (b) => b.codigo === v?.codigo
                                    ) || 'Banco inválido'
                                : null,
                            ]"
                            item-text="valor"
                            item-value="codigo"
                            return-object
                          >
                            <template v-slot:label><div>*Banco</div></template>
                          </v-autocomplete>
                        </v-col>
                        <v-col md="4" sm="4" cols="8">
                          <v-text-field
                            maxlength="6"
                            outlined
                            v-model="formData.passo5.nrAgencia"
                            @input="fieldUpdate"
                            :rules="[!isLogado ? obrigatorio : null]"
                            label="*Nº Agência"
                          />
                        </v-col>
                        <v-col md="2" sm="2" cols="4">
                          <v-text-field
                            maxlength="2"
                            outlined
                            v-model="formData.passo5.nrAgenciaDig"
                            @input="fieldUpdate"
                            :rules="[!isLogado ? obrigatorio : null]"
                            label="*Dígito"
                          />
                        </v-col>
                        <v-col md="4" sm="4" cols="8">
                          <v-text-field
                            maxlength="11"
                            outlined
                            v-model="formData.passo5.nrConta"
                            @input="fieldUpdate"
                            :rules="[!isLogado ? obrigatorio : null]"
                            label="*Nº Conta"
                          />
                        </v-col>
                        <v-col md="2" sm="2" cols="4">
                          <v-text-field
                            maxlength="3"
                            outlined
                            v-model="formData.passo5.nrContaDig"
                            @input="fieldUpdate"
                            :rules="[!isLogado ? obrigatorio : null]"
                            label="*Dígito"
                          />
                        </v-col>
                      </template>
                      <template v-else>
                        <v-col cols="12">
                          <v-file-input
                            :rules="
                              formData.passo5.semDadosBancarios
                                ? []
                                : [
                                    !isLogado ? obrigatorioArquivo : null,
                                    tamanhoInvalido,
                                  ]
                            "
                            accept="image/png, image/jpeg, image/bmp, application/pdf"
                            placeholder="Selecione um PDF ou a(s) foto(s) do documento"
                            label="*Imagem ou PDF do comprovante de documento bancário"
                            counter
                            multiple
                            small-chips
                            outlined
                            show-size
                            v-model="formData.passo5.docBancario"
                          />
                        </v-col>
                      </template>
                    </v-row>

                    <v-row
                      v-if="
                        isDocPendente &&
                        formData.emailItens.includes(
                          'Comprovante de Dados Bancários'
                        )
                      "
                    >
                      <v-col md="12"> </v-col>
                      <v-col md="12">
                        <p style="md-12" class="titulo-azul text-h5">
                          Preencha os dados bancários:
                        </p>
                        <p style="md-12">
                          Conta Corrente Pessoa Física (não pode ser conta
                          poupança). <br />
                          <strong>Obs:</strong>Se conta corrente
                          <strong>CONJUNTA</strong>, o credenciado deve ser o
                          titular desta conta.
                        </p>
                      </v-col>
                      <v-col md="8" sm="8" cols="12">
                        <v-checkbox
                          class="ma-0"
                          v-model="formData.passo5.semDadosBancarios"
                          label="Caso não localize seu banco e/ou agencia na lista, clique aqui"
                          color="primary"
                          @input="fieldUpdate"
                          @change="
                            formData.passo5.banco = null;
                            formData.passo5.nrAgencia = null;
                            formData.passo5.nrAgenciaDig = null;
                            formData.passo5.nrConta = null;
                            formData.passo5.nrContaDig = null;
                            formData.passo5.docBancario = null;
                          "
                          hide-details
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        style="padding: 0 12px"
                        v-if="formData.passo5.semDadosBancarios"
                      >
                        <label
                          class="titulo-azul"
                          style="font-size: 12px; padding: 0"
                        >
                          <strong
                            >Adicionar comprovante com os dados bancários
                            contendo as seguintes informações (Número do Banco /
                            Nome do Banco / Agencia / Conta Corrente / Digito)
                          </strong></label
                        >
                      </v-col>
                      <template v-if="!formData.passo5.semDadosBancarios">
                        <v-col md="12" sm="12" cols="12">
                          <v-autocomplete
                            autocomplete="nope"
                            outlined
                            v-model="formData.passo5.banco"
                            :items="formData.passo5.listaBancos"
                            @input="fieldUpdate"
                            :rules="[
                              !isLogado ? obrigatorio : null,
                              !isLogado
                                ? (v) =>
                                    formData.passo5.listaBancos.some(
                                      (b) => b.codigo === v?.codigo
                                    ) || 'Banco inválido'
                                : null,
                            ]"
                            item-text="valor"
                            item-value="codigo"
                            return-object
                          >
                            <template v-slot:label><div>*Banco</div></template>
                          </v-autocomplete>
                        </v-col>
                        <v-col md="4" sm="4" cols="8">
                          <v-text-field
                            maxlength="6"
                            outlined
                            v-model="formData.passo5.nrAgencia"
                            @input="fieldUpdate"
                            :rules="[!isLogado ? obrigatorio : null]"
                            label="*Nº Agência"
                          />
                        </v-col>
                        <v-col md="2" sm="2" cols="4">
                          <v-text-field
                            maxlength="2"
                            outlined
                            v-model="formData.passo5.nrAgenciaDig"
                            @input="fieldUpdate"
                            :rules="[!isLogado ? obrigatorio : null]"
                            label="*Dígito"
                          />
                        </v-col>
                        <v-col md="4" sm="4" cols="8">
                          <v-text-field
                            maxlength="11"
                            outlined
                            v-model="formData.passo5.nrConta"
                            @input="fieldUpdate"
                            :rules="[!isLogado ? obrigatorio : null]"
                            label="*Nº Conta"
                          />
                        </v-col>
                        <v-col md="2" sm="2" cols="4">
                          <v-text-field
                            maxlength="3"
                            outlined
                            v-model="formData.passo5.nrContaDig"
                            @input="fieldUpdate"
                            :rules="[!isLogado ? obrigatorio : null]"
                            label="*Dígito"
                          />
                        </v-col>
                      </template>
                      <template v-else>
                        <v-col cols="12">
                          <v-file-input
                            :rules="
                              formData.passo5.semDadosBancarios
                                ? []
                                : [
                                    !isLogado ? obrigatorioArquivo : null,
                                    tamanhoInvalido,
                                  ]
                            "
                            accept="image/png, image/jpeg, image/bmp, application/pdf"
                            placeholder="Selecione um PDF ou a(s) foto(s) do documento"
                            label="*Imagem ou PDF do comprovante de documento bancário"
                            counter
                            multiple
                            small-chips
                            outlined
                            show-size
                            v-model="formData.passo5.docBancario"
                          />
                        </v-col>
                      </template>
                    </v-row>

                    <v-row>
                      <v-col md="12">
                        <p style="md-12" class="titulo-azul text-h5">
                          Anexo de documentos obrigatórios para o
                          credenciamento:
                        </p>
                      </v-col>

                      <v-col
                        md="12"
                        sm="12"
                        cols="12"
                        v-if="isPJ && exibirDocPendente('CRO da Clínica')"
                      >
                        <v-card class="mx-auto" outlined>
                          <v-card-text>
                            <v-row>
                              <v-col md="4" sm="4" cols="12">
                                <label class="label-f18">
                                  CRO da Clínica
                                </label>
                                <br />
                                <label class="titulo-azul">
                                  *Aceitamos protocolo
                                </label>
                              </v-col>
                              <v-col md="8" sm="8" cols="12">
                                <v-checkbox
                                  class="ma-0"
                                  v-model="formData.passo5.semCroClinica"
                                  label="Não possuo este documento"
                                  color="primary"
                                  @input="fieldUpdate"
                                  @change="
                                    formData.passo5.justifSemCroClinica = null;
                                    formData.passo5.docCroClinica = null;
                                  "
                                  hide-details
                                />
                              </v-col>
                            </v-row>
                            <v-row v-show="formData.passo5.semCroClinica">
                              <v-col md="12" sm="12" cols="12">
                                <v-text-field
                                  outlined
                                  label="*Justificar a ausência do CRO da Clínica"
                                  placeholder="A solicitação de credenciamento passará por análise e está sujeita a ser reprovada pela ausência deste documento."
                                  :rules="
                                    formData.passo5.semCroClinica
                                      ? [!isLogado ? obrigatorio : null]
                                      : []
                                  "
                                  v-model="formData.passo5.justifSemCroClinica"
                                />
                              </v-col>
                            </v-row>
                            <v-row v-show="!formData.passo5.semCroClinica">
                              <v-col md="12" sm="12" cols="12">
                                <v-file-input
                                  :rules="
                                    formData.passo5.semCroClinica
                                      ? []
                                      : [
                                          !isLogado ? obrigatorioArquivo : null,
                                          tamanhoInvalido,
                                        ]
                                  "
                                  accept="image/png, image/jpeg, image/bmp, application/pdf"
                                  placeholder="Selecione um PDF ou a(s) foto(s) do documento"
                                  label="*Imagem ou PDF do CRO da Clínica"
                                  counter
                                  multiple
                                  small-chips
                                  outlined
                                  show-size
                                  :disabled="formData.passo5.semCroClinica"
                                  v-model="formData.passo5.docCroClinica"

                                  @change="
                                    formData.passo5.justifSemCroClinica = null
                                  "
                                />
                                <v-btn
                                  v-if="
                                    formData.passo5.docCroClinica &&
                                    formData.passo5.docCroClinica.length > 0
                                  "
                                  class="mr-2"
                                  @click="
                                    abrirModalDocumentos(
                                      formData.passo5.docCroClinica
                                    )
                                  "
                                  color="success"
                                  ><i class="fas fa-file-image"></i>&nbsp;Ver
                                  documentos</v-btn
                                >
                              </v-col>
                            </v-row>
                            <v-row v-show="!formData.passo5.semCroClinica">
                              <v-col md="12" sm="12" cols="12" class="pt-0">
                                <div class="text-subtitle-2">
                                  Envie um arquivo no formato JPG, PNG ou PDF
                                  com boa qualidade e que esteja legível. O
                                  arquivo deve ter no máximo 5MB.
                                </div>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-col>

                      <!-- CRO -->
                      <v-col
                        md="12"
                        sm="12"
                        cols="12"
                        v-if="
                          !isPJ &&
                          exibirDocPendente('CRO Responsável pela Clínica')
                        "
                      >
                        <v-card class="mx-auto" outlined>
                          <v-card-text>
                            <v-row>
                              <v-col md="4" sm="4" cols="12">
                                <label class="label-f18">
                                  CRO Responsável pela Clínica
                                </label>
                                <br />
                                <label class="titulo-azul">
                                  *Aceitamos protocolo
                                </label>
                              </v-col>
                              <v-col md="8" sm="8" cols="12">
                                <v-checkbox
                                  class="ma-0"
                                  v-model="formData.passo5.semCro"
                                  label="Não possuo este documento"
                                  color="primary"
                                  @input="fieldUpdate"
                                  @change="
                                    formData.passo5.justifSemCro = null;
                                    formData.passo5.docCro = null;
                                  "
                                  hide-details
                                />
                              </v-col>
                            </v-row>
                            <v-row v-show="formData.passo5.semCro">
                              <v-col md="12" sm="12" cols="12">
                                <v-text-field
                                  outlined
                                  label="*Justificar a ausência do CRO da Clínica"
                                  placeholder="A solicitação de credenciamento passará por análise e está sujeita a ser reprovada pela ausência deste documento."
                                  :rules="
                                    formData.passo5.semCro
                                      ? [!isLogado ? obrigatorio : null]
                                      : []
                                  "
                                  v-model="formData.passo5.justifSemCro"
                                />
                              </v-col>
                            </v-row>
                            <v-row v-show="!formData.passo5.semCro">
                              <v-col md="12" sm="12" cols="12">
                                <v-file-input
                                  :rules="
                                    formData.passo5.semCro
                                      ? []
                                      : [
                                          !isLogado ? obrigatorioArquivo : null,
                                          tamanhoInvalido,
                                        ]
                                  "
                                  accept="image/png, image/jpeg, image/bmp, application/pdf"
                                  placeholder="Selecione um PDF ou a(s) foto(s) do documento"
                                  label="*Imagem ou PDF do CRO da Clínica"
                                  counter
                                  multiple
                                  small-chips
                                  outlined
                                  show-size
                                  :disabled="formData.passo5.semCro"
                                  v-model="formData.passo5.docCro"

                                  @change="formData.passo5.justifSemCro = null"
                                />
                                <v-btn
                                  v-if="
                                    formData.passo5.docCro &&
                                    formData.passo5.docCro.length > 0
                                  "
                                  class="mr-2"
                                  @click="
                                    abrirModalDocumentos(formData.passo5.docCro)
                                  "
                                  color="success"
                                  ><i class="fas fa-file-image"></i>&nbsp;Ver
                                  documentos</v-btn
                                >
                              </v-col>
                            </v-row>
                            <v-row v-show="!formData.passo5.semCro">
                              <v-col md="12" sm="12" cols="12" class="pt-0">
                                <div class="text-subtitle-2">
                                  Envie um arquivo no formato JPG, PNG ou PDF
                                  com boa qualidade e que esteja legível. O
                                  arquivo deve ter no máximo 5MB.
                                </div>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-col>

                      <v-col
                        md="12"
                        sm="12"
                        cols="12"
                        v-if="
                          isDocPendente && !isPJ && exibirDocPendente('CRO')
                        "
                      >
                        <v-card class="mx-auto" outlined>
                          <v-card-text>
                            <v-row>
                              <v-col md="4" sm="4" cols="12">
                                <label class="label-f18">
                                  CRO Responsável pela Clínica
                                </label>
                                <br />
                                <label class="titulo-azul">
                                  *Aceitamos protocolo
                                </label>
                              </v-col>
                              <v-col md="8" sm="8" cols="12">
                                <v-checkbox
                                  class="ma-0"
                                  v-model="formData.passo5.semCro"
                                  label="Não possuo este documento"
                                  color="primary"
                                  @input="fieldUpdate"
                                  @change="
                                    formData.passo5.justifSemCro = null;
                                    formData.passo5.docCro = null;
                                  "
                                  hide-details
                                />
                              </v-col>
                            </v-row>
                            <v-row v-show="formData.passo5.semCro">
                              <v-col md="12" sm="12" cols="12">
                                <v-text-field
                                  outlined
                                  label="*Justificar a ausência do CRO da Clínica"
                                  placeholder="A solicitação de credenciamento passará por análise e está sujeita a ser reprovada pela ausência deste documento."
                                  :rules="
                                    formData.passo5.semCro
                                      ? [!isLogado ? obrigatorio : null]
                                      : []
                                  "
                                  v-model="formData.passo5.justifSemCro"
                                />
                              </v-col>
                            </v-row>
                            <v-row v-show="!formData.passo5.semCro">
                              <v-col md="12" sm="12" cols="12">
                                <v-file-input
                                  :rules="
                                    formData.passo5.semCro
                                      ? []
                                      : [
                                          !isLogado ? obrigatorioArquivo : null,
                                          tamanhoInvalido,
                                        ]
                                  "
                                  accept="image/png, image/jpeg, image/bmp, application/pdf"
                                  placeholder="Selecione um PDF ou a(s) foto(s) do documento"
                                  label="*Imagem ou PDF do CRO da Clínica"
                                  counter
                                  multiple
                                  small-chips
                                  outlined
                                  show-size
                                  :disabled="formData.passo5.semCro"
                                  v-model="formData.passo5.docCro"

                                  @change="formData.passo5.justifSemCro = null"
                                />
                                <v-btn
                                  v-if="
                                    formData.passo5.docCro &&
                                    formData.passo5.docCro.length > 0
                                  "
                                  class="mr-2"
                                  @click="
                                    abrirModalDocumentos(formData.passo5.docCro)
                                  "
                                  color="success"
                                  ><i class="fas fa-file-image"></i>&nbsp;Ver
                                  documentos</v-btn
                                >
                              </v-col>
                            </v-row>
                            <v-row v-show="!formData.passo5.semCro">
                              <v-col md="12" sm="12" cols="12" class="pt-0">
                                <div class="text-subtitle-2">
                                  Envie um arquivo no formato JPG, PNG ou PDF
                                  com boa qualidade e que esteja legível. O
                                  arquivo deve ter no máximo 5MB.
                                </div>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-col>

                      <!-- CRO do responsável pela clínica -->
                      <v-col
                        md="12"
                        sm="12"
                        cols="12"
                        v-if="
                          isPJ &&
                          exibirDocPendente('CRO Responsável pela Clínica')
                        "
                      >
                        <v-card class="mx-auto" outlined>
                          <v-card-text>
                            <v-row>
                              <v-col md="4" sm="4" cols="12">
                                <label
                                  class="label-f18"
                                  style="font-size: 16 !important"
                                >
                                  CRO do responsável pela clínica
                                </label>
                                <br />
                                <label class="titulo-azul">
                                  *Aceitamos protocolo
                                </label>
                              </v-col>
                              <v-col md="8" sm="8" cols="12">
                                <v-checkbox
                                  class="ma-0"
                                  v-model="formData.passo5.semCroRespClinica"
                                  label="Não possuo este documento"
                                  color="primary"
                                  @input="fieldUpdate"
                                  @change="
                                    formData.passo5.justifSemCroRespClinica =
                                      null;
                                    formData.passo5.docCroRespClinica = null;
                                  "
                                  hide-details
                                ></v-checkbox>
                              </v-col>
                            </v-row>
                            <v-row v-show="formData.passo5.semCroRespClinica">
                              <v-col md="12" sm="12" cols="12">
                                <v-text-field
                                  outlined
                                  label="*Justificar a ausência do CRO do responsável pela clínica"
                                  placeholder="A solicitação de credenciamento passará por análise e está sujeita a ser reprovada pela ausência deste documento."
                                  :rules="
                                    formData.passo5.semCroRespClinica
                                      ? [!isLogado ? obrigatorio : null]
                                      : []
                                  "
                                  v-model="
                                    formData.passo5.justifSemCroRespClinica
                                  "
                                />
                              </v-col>
                            </v-row>
                            <v-row v-show="!formData.passo5.semCroRespClinica">
                              <v-col md="12" sm="12" cols="12">
                                <v-file-input
                                  :rules="
                                    formData.passo5.semCroRespClinica
                                      ? []
                                      : [
                                          !isLogado ? obrigatorioArquivo : null,
                                          tamanhoInvalido,
                                        ]
                                  "
                                  accept="image/png, image/jpeg, image/bmp, application/pdf"
                                  placeholder="Selecione um PDF ou a(s) foto(s) do documento"
                                  label="*Imagem ou PDF do CRO do responsável pela clínica"
                                  counter
                                  multiple
                                  small-chips
                                  outlined
                                  show-size
                                  :disabled="formData.passo5.semCroRespClinica"
                                  v-model="formData.passo5.docCroRespClinica"
                                  @change="
                                    formData.passo5.justifSemCroRespClinica =
                                      null
                                  "
                                ></v-file-input>
                                <v-btn
                                  v-if="
                                    formData.passo5.docCroRespClinica &&
                                    formData.passo5.docCroRespClinica.length > 0
                                  "
                                  class="mr-2"
                                  @click="
                                    abrirModalDocumentos(
                                      formData.passo5.docCroRespClinica
                                    )
                                  "
                                  color="success"
                                  ><i class="fas fa-file-image"></i>&nbsp;Ver
                                  documentos</v-btn
                                >
                              </v-col>
                            </v-row>
                            <v-row v-show="!formData.passo5.semCroRespClinica">
                              <v-col md="12" sm="12" cols="12" class="pt-0">
                                <div class="text-subtitle-2">
                                  Envie um arquivo no formato JPG, PNG ou PDF
                                  com boa qualidade e que esteja legível. O
                                  arquivo deve ter no máximo 5MB.
                                </div>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-col>

                      <!-- Cópia do Contrato Social -->
                      <v-col
                        md="12"
                        sm="12"
                        cols="12"
                        v-if="isPJ && exibirDocPendente('Contrato Social')"
                      >
                        <v-card class="mx-auto" outlined>
                          <v-card-text>
                            <v-row>
                              <v-col md="4" sm="4" cols="12">
                                <label class="label-f18">
                                  Cópia do Contrato Social
                                </label>
                                <br />
                                <label class="titulo-azul">
                                  *Aceitamos protocolo
                                </label>
                              </v-col>
                              <v-col md="8" sm="8" cols="12">
                                <v-checkbox
                                  class="ma-0"
                                  v-model="formData.passo5.semContratoSocial"
                                  label="Não possuo este documento"
                                  color="primary"
                                  @input="fieldUpdate"
                                  @change="
                                    formData.passo5.justifSemContratoSocial =
                                      null;
                                    formData.passo5.docContratoSocial = null;
                                  "
                                  hide-details
                                ></v-checkbox>
                              </v-col>
                            </v-row>
                            <v-row v-show="formData.passo5.semContratoSocial">
                              <v-col md="12" sm="12" cols="12">
                                <v-text-field
                                  outlined
                                  label="*Justificar a ausência do Contrato Social"
                                  placeholder="A solicitação de credenciamento passará por análise e está sujeita a ser reprovada pela ausência deste documento."
                                  :rules="
                                    formData.passo5.semContratoSocial
                                      ? [!isLogado ? obrigatorio : null]
                                      : []
                                  "
                                  v-model="
                                    formData.passo5.justifSemContratoSocial
                                  "
                                />
                              </v-col>
                            </v-row>
                            <v-row v-show="!formData.passo5.semContratoSocial">
                              <v-col md="12" sm="12" cols="12">
                                <v-file-input
                                  :rules="
                                    formData.passo5.semContratoSocial
                                      ? []
                                      : [
                                          !isLogado ? obrigatorioArquivo : null,
                                          tamanhoInvalido,
                                        ]
                                  "
                                  accept="image/png, image/jpeg, image/bmp, application/pdf"
                                  placeholder="Selecione um PDF ou a(s) foto(s) do documento"
                                  label="*Imagem ou PDF do Contrato Social"
                                  counter
                                  multiple
                                  small-chips
                                  outlined
                                  show-size
                                  :disabled="formData.passo5.semContratoSocial"
                                  v-model="formData.passo5.docContratoSocial"
                                  @change="
                                    formData.passo5.justifSemContratoSocial =
                                      null
                                  "
                                />
                                <v-btn
                                  v-if="
                                    formData.passo5.docContratoSocial &&
                                    formData.passo5.docContratoSocial.length > 0
                                  "
                                  class="mr-2"
                                  @click="
                                    abrirModalDocumentos(
                                      formData.passo5.docContratoSocial
                                    )
                                  "
                                  color="success"
                                  ><i class="fas fa-file-image"></i>&nbsp;Ver
                                  documentos</v-btn
                                >
                              </v-col>
                            </v-row>
                            <v-row v-show="!formData.passo5.semContratoSocial">
                              <v-col md="12" sm="12" cols="12" class="pt-0">
                                <div class="text-subtitle-2">
                                  Envie um arquivo no formato JPG, PNG ou PDF
                                  com boa qualidade e que esteja legível. O
                                  arquivo deve ter no máximo 5MB.
                                </div>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-col>

                      <!-- ALVARÁ DE FUNCIONAMENTO -->
                      <v-col
                        md="12"
                        sm="12"
                        cols="12"
                        v-if="exibirDocPendente('Alvará de Funcionamento')"
                      >
                        <v-card class="mx-auto" outlined>
                          <v-card-text>
                            <v-row>
                              <v-col md="4" sm="4" cols="12">
                                <label class="label-f18">
                                  Alvará de Funcionamento
                                </label>
                                <br />
                                <label class="titulo-azul">
                                  *Aceitamos protocolo
                                </label>
                              </v-col>
                              <v-col md="8" sm="8" cols="12">
                                <v-checkbox
                                  class="ma-0"
                                  v-model="
                                    formData.passo5.semAlvaraFuncionamento
                                  "
                                  label="Não possuo este documento"
                                  color="primary"
                                  :disabled="alvaraDisabled"
                                  @input="fieldUpdate"
                                  @change="
                                    formData.passo5.justifSemAlvara = null;
                                    formData.passo5.docAlvara = null;
                                    formData.passo5.nrAlvaraFuncionamento =
                                      this.$route.params.passo5.nrAlvaraFuncionamento;
                                    formData.passo5.dataEmissaoAlvaraFuncionamento =
                                      null;
                                    formData.passo5.dataValidadeAlvaraFuncionamento =
                                      null;
                                    formData.passo5.protocoloAlvaraFuncionamento = false;
                                    formData.passo5.validadeIndeterminadaAlvaraFuncionamento = false;
                                  "
                                  hide-details
                                ></v-checkbox>
                              </v-col>
                            </v-row>
                            <v-row
                              v-show="formData.passo5.semAlvaraFuncionamento"
                            >
                              <v-col md="12" sm="12" cols="12">
                                <v-text-field
                                  outlined
                                  label="*Justificar a ausência do Alvará da Funcionamento"
                                  placeholder="A solicitação de credenciamento passará por análise e está sujeita a ser reprovada pela ausência deste documento."
                                  :rules="
                                    formData.passo5.semAlvaraFuncionamento
                                      ? [!isLogado ? obrigatorio : null]
                                      : []
                                  "
                                  v-model="formData.passo5.justifSemAlvara"
                                />
                              </v-col>
                            </v-row>
                            <v-row
                              v-show="!formData.passo5.semAlvaraFuncionamento"
                            >
                              <v-col md="8" sm="8" cols="12">
                                <v-file-input
                                  :rules="
                                    formData.passo5.semAlvaraFuncionamento
                                      ? []
                                      : [
                                          !isLogado ? obrigatorioArquivo : null,
                                          tamanhoInvalido,
                                        ]
                                  "
                                  accept="image/png, image/jpeg, image/bmp, application/pdf"
                                  placeholder="Selecione um PDF ou a(s) foto(s) do documento"
                                  label="*Imagem ou PDF do Alvará da Funcionamento ou do Protocolo"
                                  counter
                                  multiple
                                  small-chips
                                  outlined
                                  show-size
                                  :disabled="
                                    formData.passo5.semAlvaraFuncionamento
                                  "
                                  v-model="formData.passo5.docAlvara"
                                  @change="
                                    formData.passo5.justifSemAlvara = null
                                  "
                                ></v-file-input>
                              </v-col>
                              <v-col md="4" sm="4" cols="12">
                                <v-text-field
                                  outlined
                                  v-model="
                                    formData.passo5.nrAlvaraFuncionamento
                                  "
                                  label="*Nº do Alvará ou Protocolo"
                                  v-mask="'###############'"
                                  inputmode="numeric"
                                  @input="fieldUpdate"
                                ></v-text-field>
                              </v-col>
                              <v-col md="3" sm="6" cols="12">
                                <v-text-field
                                  outlined
                                  label="Data de emissão"
                                  prepend-inner-icon="event"
                                  v-mask="'##/##/####'"
                                  inputmode="numeric"
                                  placeholder="__/__/____"
                                  :rules="[dataValida]"
                                  v-model="
                                    formData.passo5
                                      .dataEmissaoAlvaraFuncionamento
                                  "
                                />
                              </v-col>
                              <v-col md="3" sm="6" cols="12">
                                <v-text-field
                                  outlined
                                  label="Data de validade"
                                  prepend-inner-icon="event"
                                  v-mask="'##/##/####'"
                                  inputmode="numeric"
                                  placeholder="__/__/____"
                                  :rules="[dataValida]"
                                  v-model="
                                    formData.passo5
                                      .dataValidadeAlvaraFuncionamento
                                  "
                                />
                              </v-col>
                              <v-col md="3" sm="3" cols="6">
                                <v-checkbox
                                  v-model="
                                    formData.passo5.protocoloAlvaraFuncionamento
                                  "
                                  label="Possui apenas o protocolo da solicitação"
                                  color="primary"
                                  @input="fieldUpdate"
                                  hide-details
                                  class="ma-0"
                                ></v-checkbox>
                              </v-col>
                              <v-col md="3" sm="3" cols="6">
                                <v-checkbox
                                  v-model="
                                    formData.passo5
                                      .validadeIndeterminadaAlvaraFuncionamento
                                  "
                                  label="Validade Indeterminada"
                                  color="primary"
                                  @input="fieldUpdate"
                                  hide-details
                                  class="ma-0"
                                ></v-checkbox>
                              </v-col>
                              <v-col cols="12">
                                <v-btn
                                  v-if="
                                    formData.passo5.docAlvara &&
                                    formData.passo5.docAlvara.length > 0
                                  "
                                  class="mr-2"
                                  @click="
                                    abrirModalDocumentos(
                                      formData.passo5.docAlvara
                                    )
                                  "
                                  color="success"
                                  ><i class="fas fa-file-image"></i>&nbsp;Ver
                                  documentos</v-btn
                                >
                              </v-col>
                            </v-row>
                            <v-row
                              v-show="!formData.passo5.semAlvaraFuncionamento"
                            >
                              <v-col md="12" sm="12" cols="12" class="pt-0">
                                <div class="text-subtitle-2">
                                  Envie um arquivo no formato JPG, PNG ou PDF
                                  com boa qualidade e que esteja legível. O
                                  arquivo deve ter no máximo 5MB.
                                </div>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-col>

                      <!-- ALVARÁ DA VIGILANCIA SANITÁRIA -->
                      <v-col
                        md="12"
                        sm="12"
                        cols="12"
                        v-if="
                          exibirDocPendente('Alvará da Vigilância Sanitária')
                        "
                      >
                        <v-card class="mx-auto" outlined>
                          <v-card-text>
                            <v-row>
                              <v-col md="4" sm="4" cols="12">
                                <label class="label-f18">
                                  Alvará da Vigilância Sanitária
                                </label>
                                <br />
                                <label class="titulo-azul">
                                  *Aceitamos protocolo
                                </label>
                              </v-col>
                              <v-col md="8" sm="8" cols="12">
                                <v-checkbox
                                  class="ma-0"
                                  v-model="formData.passo5.semAlvaraVigiSanit"
                                  label="Não possuo este documento"
                                  color="primary"
                                  @input="fieldUpdate"
                                  @change="
                                    formData.passo5.justifSemAlvaraVigiSanit =
                                      null;
                                    formData.passo5.docAlvaraVigiSanit = null;
                                    formData.passo5.nrAlvaraVigiSanit =
                                      this.$route.params.passo5.nrAlvaraVigiSanit;
                                    formData.passo5.dataEmissaoAlvaraVigiSanit =
                                      null;
                                    formData.passo5.dataValidadeAlvaraVigiSanit =
                                      null;
                                    formData.passo5.protocoloAlvaraVigiSanit = false;
                                    formData.passo5.validadeIndeterminadaAlvaraVigiSanit = false;
                                  "
                                  hide-details
                                ></v-checkbox>
                              </v-col>
                            </v-row>
                            <v-row v-show="formData.passo5.semAlvaraVigiSanit">
                              <v-col md="12" sm="12" cols="12">
                                <v-text-field
                                  outlined
                                  label="*Justificar a ausência do Alvará da Vigilância Sanitária"
                                  placeholder="A solicitação de credenciamento passará por análise e está sujeita a ser reprovada pela ausência deste documento."
                                  :rules="
                                    formData.passo5.semAlvaraVigiSanit
                                      ? [!isLogado ? obrigatorio : null]
                                      : []
                                  "
                                  v-model="
                                    formData.passo5.justifSemAlvaraVigiSanit
                                  "
                                />
                              </v-col>
                            </v-row>
                            <v-row v-show="!formData.passo5.semAlvaraVigiSanit">
                              <v-col md="8" sm="8" cols="12">
                                <v-file-input
                                  :rules="
                                    formData.passo5.semAlvaraVigiSanit
                                      ? []
                                      : [
                                          !isLogado ? obrigatorioArquivo : null,
                                          tamanhoInvalido,
                                        ]
                                  "
                                  accept="image/png, image/jpeg, image/bmp, application/pdf"
                                  placeholder="Selecione um PDF ou a(s) foto(s) do documento"
                                  label="*Imagem ou PDF do Alvará da Vigilância Sanitária ou do Protocolo"
                                  counter
                                  multiple
                                  small-chips
                                  outlined
                                  show-size
                                  :disabled="formData.passo5.semAlvaraVigiSanit"
                                  v-model="formData.passo5.docAlvaraVigiSanit"
                                  @change="
                                    formData.passo5.justifSemAlvaraVigiSanit =
                                      null
                                  "
                                ></v-file-input>
                              </v-col>
                              <v-col md="4" sm="4" cols="12">
                                <v-text-field
                                  outlined
                                  v-model="formData.passo5.nrAlvaraVigiSanit"
                                  label="*Nº do Alvará ou Protocolo"
                                  v-mask="'###############'"
                                  inputmode="numeric"
                                  @input="fieldUpdate"
                                ></v-text-field>
                              </v-col>
                              <v-col md="3" sm="6" cols="12">
                                <v-text-field
                                  outlined
                                  label="Data de emissão"
                                  prepend-inner-icon="event"
                                  v-mask="'##/##/####'"
                                  inputmode="numeric"
                                  placeholder="__/__/____"
                                  :rules="[dataValida]"
                                  v-model="
                                    formData.passo5.dataEmissaoAlvaraVigiSanit
                                  "
                                />
                              </v-col>
                              <v-col md="3" sm="6" cols="12">
                                <v-text-field
                                  outlined
                                  label="Data de validade"
                                  prepend-inner-icon="event"
                                  v-mask="'##/##/####'"
                                  inputmode="numeric"
                                  placeholder="__/__/____"
                                  :rules="[dataValida]"
                                  v-model="
                                    formData.passo5.dataValidadeAlvaraVigiSanit
                                  "
                                />
                              </v-col>
                              <v-col md="3" sm="3" cols="6">
                                <v-checkbox
                                  v-model="
                                    formData.passo5.protocoloAlvaraVigiSanit
                                  "
                                  label="Possui apenas o protocolo da solicitação"
                                  color="primary"
                                  @input="fieldUpdate"
                                  hide-details
                                  class="ma-0"
                                ></v-checkbox>
                              </v-col>
                              <v-col md="3" sm="3" cols="6">
                                <v-checkbox
                                  v-model="
                                    formData.passo5
                                      .validadeIndeterminadaAlvaraVigiSanit
                                  "
                                  label="Validade Indeterminada"
                                  color="primary"
                                  @input="fieldUpdate"
                                  hide-details
                                  class="ma-0"
                                ></v-checkbox>
                              </v-col>
                              <v-col cols="12">
                                <v-btn
                                  v-if="
                                    formData.passo5.docAlvaraVigiSanit &&
                                    formData.passo5.docAlvaraVigiSanit.length >
                                      0
                                  "
                                  class="mr-2"
                                  @click="
                                    abrirModalDocumentos(
                                      formData.passo5.docAlvaraVigiSanit
                                    )
                                  "
                                  color="success"
                                  ><i class="fas fa-file-image"></i>&nbsp;Ver
                                  documentos</v-btn
                                >
                              </v-col>
                            </v-row>
                            <v-row v-show="!formData.passo5.semAlvaraVigiSanit">
                              <v-col md="12" sm="12" cols="12" class="pt-0">
                                <div class="text-subtitle-2">
                                  Envie um arquivo no formato JPG, PNG ou PDF
                                  com boa qualidade e que esteja legível. O
                                  arquivo deve ter no máximo 5MB.
                                </div>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-col>

                      <!--  CERTIFICADO DE ESPECIALIDADES -->
                      <v-col
                        md="12"
                        sm="12"
                        cols="12"
                        v-if="
                          exibirDocPendente('Certificado de Especialização') &&
                          this.formData.passo1.tipoDocumento == 'F'
                        "
                      >
                        <v-card class="mx-auto" outlined>
                          <v-card-text>
                            <v-row>
                              <v-col md="4" sm="4" cols="12">
                                <label class="label-f18">
                                  Certificado de Especialidades
                                </label>
                                <br />
                              </v-col>
                              <v-col md="8" sm="8" cols="12">
                                <v-checkbox
                                  class="ma-0"
                                  v-model="formData.passo5.semCertificado"
                                  label="Não possuo este documento"
                                  color="primary"
                                  @input="fieldUpdate"
                                  @change="
                                    (formData.passo5.certificados = []),
                                      (formData.passo5.semCertificadoEsp = null)
                                  "
                                  hide-details
                                ></v-checkbox>
                              </v-col>
                            </v-row>
                            <v-row v-show="formData.passo5.semCertificado">
                              <v-col md="12" sm="12" cols="12">
                                <v-text-field
                                  outlined
                                  label="*Justificar a ausência do Certificado de Especialidade"
                                  placeholder="A solicitação de credenciamento passará por análise e está sujeita a ser reprovada pela ausência deste documento."
                                  :rules="
                                    formData.passo5.semCertificado
                                      ? [!isLogado ? obrigatorio : null]
                                      : []
                                  "
                                  v-model="formData.passo5.semCertificadoEsp"
                                />
                              </v-col>
                            </v-row>
                            <v-row v-show="!formData.passo5.semCertificado">
                              <v-col md="12" sm="12" cols="12">
                                <v-file-input
                                  :rules="
                                    formData.passo5.semCertificado
                                      ? []
                                      : [
                                          !isLogado ? obrigatorioArquivo : null,
                                          tamanhoInvalido,
                                        ]
                                  "
                                  accept="image/png, image/jpeg, image/bmp, application/pdf"
                                  placeholder="Selecione um PDF ou a(s) foto(s) do documento"
                                  label="*Imagem ou PDF do Certificado de Especialização"
                                  counter
                                  multiple
                                  small-chips
                                  outlined
                                  show-size
                                  :disabled="formData.passo5.semCertificado"
                                  @change="handleFileChange"
                                  :value="formData.passo5.certificados"
                                ></v-file-input>
                              </v-col>
                            </v-row>
                            <v-row v-show="!formData.passo5.semCertificado">
                              <v-col md="12" sm="12" cols="12" class="pt-0">
                                <v-col cols="12">
                                  <v-btn
                                    v-if="
                                      formData.passo5.certificados &&
                                      formData.passo5.certificados.length > 0
                                    "
                                    class="mr-2"
                                    @click="
                                      abrirModalDocumentos(
                                        formData.passo5.certificados
                                      )
                                    "
                                    color="success"
                                    ><i class="fas fa-file-image"></i>&nbsp;Ver
                                    documentos</v-btn
                                  >
                                </v-col>
                                <div class="text-subtitle-2">
                                  Envie um arquivo no formato JPG, PNG ou PDF
                                  com boa qualidade e que esteja legível. O
                                  arquivo deve ter no máximo 5MB.
                                </div>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-col>

                      <!-- Contratos - (Docusign / Digitalizado) -->
                      <v-col
                        md="12"
                        sm="12"
                        cols="12"
                        v-if="
                          isLogado &&
                          exibirDocPendente(
                            'Contratos - (Docusign / Digitalizado)'
                          )
                        "
                      >
                        <v-card class="mx-auto" outlined>
                          <v-card-text>
                            <v-row>
                              <v-col md="4" sm="4" cols="12">
                                <label
                                  class="label-f18"
                                  style="font-size: 16 !important"
                                >
                                  Contratos - (Docusign / Digitalizado)
                                </label>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col md="12" sm="12" cols="12">
                                <v-file-input
                                  accept="image/png, image/jpeg, image/bmp, application/pdf"
                                  placeholder="Selecione um PDF ou a(s) foto(s) do documento"
                                  label="Imagem ou PDF do CRO da Clínica"
                                  counter
                                  multiple
                                  small-chips
                                  outlined
                                  show-size
                                  v-model="formData.passo5.docContratoDocusign"
                                />
                                <v-btn
                                  v-if="
                                    formData.passo5.docContratoDocusign &&
                                    formData.passo5.docContratoDocusign.length >
                                      0
                                  "
                                  class="mr-2"
                                  @click="
                                    abrirModalDocumentos(
                                      formData.passo5.docContratoDocusign
                                    )
                                  "
                                  color="success"
                                  ><i class="fas fa-file-image"></i>&nbsp;Ver
                                  documentos</v-btn
                                >
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col md="12" sm="12" cols="12" class="pt-0">
                                <div class="text-subtitle-2">
                                  Envie um arquivo no formato JPG, PNG ou PDF
                                  com boa qualidade e que esteja legível. O
                                  arquivo deve ter no máximo 5MB.
                                </div>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col md="12" sm="12" cols="12">
                        <v-divider></v-divider>
                      </v-col>
                    </v-row>
                    <v-row
                      v-if="!isRadiologiaOuEmergencia && isPJ && !isDocPendente"
                    >
                      <v-col md="12" cols="12">
                        <v-data-table
                          :headers="headers"
                          :items="formData.passo5.listaCorpoClinico"
                          sort-by="name"
                          class="elevation-1"
                        >
                          <template v-slot:top>
                            <v-toolbar flat>
                              <div
                                class="d-flex justify-space-between align-center"
                                style="width: 100%"
                              >
                                <v-toolbar-title>Corpo Clínico</v-toolbar-title>
                                <v-btn
                                  color="primary"
                                  dark
                                  class="mb-2"
                                  @click="adicionarNovoDentista"
                                  v-if="!isDocPendente"
                                >
                                  Adicionar
                                  <i class="fas fa-plus"></i>
                                </v-btn>
                              </div>
                            </v-toolbar>
                          </template>
                          <template v-slot:[`item.actions`]="{ item }">
                            <v-btn
                              icon
                              small
                              class="mr-2"
                              @click="editItem(item)"
                            >
                              <i class="fas fa-pen" />
                            </v-btn>
                            <v-btn icon small @click="deleteItem(item)">
                              <i class="fas fa-trash" />
                            </v-btn>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col md="12" cols="12" class="text-right">
                        <v-btn
                          v-if="!isDocPendente"
                          class="mr-2"
                          color="secundary"
                          @click="passoAtual = 4"
                          >Voltar</v-btn
                        >
                        <v-btn class="mr-2" color="primary" @click="next"
                          >Finalizar</v-btn
                        >
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog v-model="dialog" max-width="310">
      <v-card>
        <v-card-title class="label-f18">Atenção</v-card-title>
        <v-card-text>
          <p v-html="msg"></p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary darken-1" text @click="dialog = false">
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogAlterarEspec" max-width="460">
      <v-card>
        <v-card-title class="label-f18"> Atenção </v-card-title>
        <v-card-text>
          <br />
          <p>
            Ao optar por alterar as especialidades você será redirecionado para
            a tela principal.
          </p>
          <p>Clique em ALTERAR CADASTRO na mensagem.</p>
          <br />
          <p>
            Não se preocupe, você não perderá os dados preenchidos até o
            momento.
          </p>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="error darken-1"
            text
            @click="dialogAlterarEspec = false"
          >
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary darken-1" text @click="alterarEspecialidades()">
            Continuar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogCorpoClinico">
      <v-card style="padding: 16px">
        <v-form ref="formCorpoClinico" v-model="validFormCorpoClinico">
          <v-row>
            <v-col md="12">
              <p style="md-12" class="titulo-azul text-h5">Corpo Clínico:</p>
            </v-col>
          </v-row>

          <v-row>
            <v-col md="6" sm="12" cols="12">
              <v-text-field
                outlined
                label="*Nome"
                maxlength="70"
                :rules="[!isLogado ? obrigatorio : null, checaNomeAbreviado]"
                v-model="editedItem.name"
              />
            </v-col>
            <v-col md="3" sm="6" cols="12">
              <!-- Campo CRO -->
              <v-text-field
                outlined
                label="*CRO"
                placeholder="CRO"
                @input="fieldUpdate"
                :rules="[!isLogado ? obrigatorio : null]"
                maxlength="7"
                @keyup="editedItem.cro = editedItem.cro.toUpperCase()"
                v-model="editedItem.cro"
              />
            </v-col>

            <v-col md="3" sm="6" cols="12">
              <!-- Campo UF -->
              <v-select
                outlined
                v-model="editedItem.uf"
                :items="listaEstados"
                label="*UF"
                item-text="nome"
                item-value="sigla"
                :rules="[!isLogado ? obrigatorio : null, checkCroConsultorioEpao]"
              />
            </v-col>

            <v-col md="3" sm="6" cols="12">
              <v-text-field
                outlined
                label="*Data de nascimento"
                prepend-inner-icon="event"
                v-mask="'##/##/####'"
                inputmode="numeric"
                placeholder="__/__/____"
                :rules="[
                  !isLogado ? obrigatorio : null,
                  dataValida,
                  checaDataFormaturaIsValida,
                ]"
                v-model="editedItem.dataNasc"
              />
            </v-col>
            <v-col md="3" sm="6" cols="12">
              <v-text-field
                outlined
                label="*RG"
                maxlength="18"
                @blur="editedItem.rg = clearAndUpper(editedItem.rg).trim()"
                @input="editedItem.rg = clearAndUpper(editedItem.rg)"
                @keydown="validarAcentos($event)"
                v-mask="'##.###.###-#'"
                inputmode="numeric"
                :rules="[!isLogado ? obrigatorio : null]"
                v-model="editedItem.rg"
              />
            </v-col>
            <v-col md="3" sm="6" cols="12">
              <v-text-field
                outlined
                label="*CPF"
                v-mask="'###.###.###-##'"
                inputmode="numeric"
                :rules="[!isLogado ? obrigatorio : null]"
                v-model="editedItem.cpf"
              />
            </v-col>
            <v-col md="3" sm="6" cols="12" v-if="isAtualizacao">
              <label>Pessoa politicamente exposta</label>
              <i
                class="fas fa-question-circle"
                style="
                  font-size: 18px;
                  cursor: pointer;
                  padding: 0 8px;
                  color: green;
                "
                @click="dialogPEP = true"
              />
              <v-radio-group v-model="editedItem.pep" row>
                <v-radio label="Sim" value="S"></v-radio>
                <v-radio label="Não" value="N"></v-radio>
              </v-radio-group>
            </v-col>
            <v-col md="3" sm="6" cols="12" v-if="isAtualizacao">
              <label>Sexo</label>
              <v-radio-group v-model="editedItem.sexo" row>
                <v-radio label="Masculino" value="M" />
                <v-radio label="Feminino" value="F" />
              </v-radio-group>
            </v-col>
          </v-row>

          <v-row>
            <v-col md="8" cols="12">
              <v-text-field
                outlined
                label="*Faculdade"
                maxlength="70"
                :rules="[!isLogado ? obrigatorio : null]"
                v-model="editedItem.faculdade"
              />
            </v-col>
            <v-col md="4" cols="12">
              <v-text-field
                outlined
                label="*Data da formatura"
                prepend-inner-icon="event"
                v-mask="'##/##/####'"
                inputmode="numeric"
                placeholder="__/__/____"
                :rules="[
                  !isLogado ? obrigatorio : null,
                  dataValida,
                  checaDataFormaturaIsValida,
                ]"
                v-model="editedItem.dataFormatura"
              />
            </v-col>

            <v-col cols="12" md="12" class="pb-16">
              <p>
                *Especialidades atendidas
                <!-- v-if="erroEspecialidade" -->
                <v-chip class="ma-2" color="red" text-color="white"
                  ><i class="fas mr-2 fa-exclamation-triangle"></i> Selecione ao
                  menos 1 especialidade</v-chip
                >
              </p>
              <v-simple-table fixed-header height="480px" class="elevation-1">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th id="idEspecialidades2">Especialidades</th>
                      <th id="idAreaDeAtuaçao2">Área de atuação</th>
                      <th id="idEspecialista2">Especialista</th>
                      <th
                        id="idEspaco21"
                        v-if="
                          editedItem.especialidades.find(
                            (x) => x.valorSelecionado === 'E'
                          )
                        "
                      >
                        Grau Instrução
                      </th>
                      <th id="idEspaco22" v-else></th>
                      <th
                        id="idSemCertificado2"
                        v-if="
                          editedItem.especialidades.find(
                            (x) => x.valorSelecionado === 'E'
                          )
                        "
                        class="d-flex justify-center align-center pa-0"
                      >
                        Sem certificado
                      </th>
                      <th id="idEspaco23" v-else></th>
                      <th
                        id="idCertificado2"
                        v-if="
                          editedItem.especialidades.find(
                            (x) => x.valorSelecionado === 'E'
                          )
                        "
                      >
                        Certificado
                      </th>
                      <th id="idEspaco24" v-else></th>
                      <th id="idEspaco25"></th>
                    </tr>
                  </thead>
                  <tbody
                    v-for="(espec, i) in editedItem.especialidades"
                    :key="'E' + i"
                  >
                    <tr>
                      <td>{{ espec.titulo }}</td>
                      <td>
                        <v-radio-group v-model="espec.valorSelecionado"
                          ><v-radio value="AA"></v-radio
                        ></v-radio-group>
                      </td>
                      <td>
                        <v-radio-group
                          v-if="espec.titulo != 'Clínica Geral'"
                          @change="espec.grauInstrucao = null"
                          v-model="espec.valorSelecionado"
                          ><v-radio value="E"></v-radio
                        ></v-radio-group>
                      </td>
                      <td>
                        <v-select
                          v-if="espec.valorSelecionado == 'E'"
                          v-model="espec.grauInstrucao"
                          :items="listaGrauInstrucao"
                          item-text="valor"
                          item-value="codigo"
                          :rules="[!isLogado ? obrigatorio : null]"
                          placeholder="*Selecione..."
                        ></v-select>
                      </td>
                      <td class="d-flex justify-center align-center pa-0">
                        <v-checkbox
                          v-if="espec.valorSelecionado == 'E'"
                          class="ma-0 pa-0"
                          v-model="espec.semCerficadoEspec"
                          color="primary"
                          @input="fieldUpdate"
                          @change="
                            espec.justificativa = null;
                            espec.certificados = null;
                          "
                          hide-details
                        ></v-checkbox>
                      </td>
                      <td
                        v-if="
                          espec.valorSelecionado == 'E' &&
                          !espec.semCerficadoEspec
                        "
                      >
                        <v-file-input
                          counter
                          show-size
                          :loading="espec.loading"
                          v-model="espec.certificados"
                          accept="image/png, image/jpeg"
                          placeholder="Anexar certificado especialização"
                          truncate-length="20"
                          :rules="
                            (espec.semCerficadoEspec
                              ? []
                              : [obrigatorioArquivo, tamanhoInvalido],
                            [
                              (value) =>
                                !value.type.includes('image')
                                  ? 'Formato do arquivo é inválido'
                                  : true,
                            ])
                          "
                          @change="espec.justificativa = null"
                        />
                      </td>
                      <td v-else>
                        <v-text-field
                          v-if="
                            espec.valorSelecionado == 'E' &&
                            espec.semCerficadoEspec
                          "
                          label="*Justificar a ausência do documento"
                          :rules="
                            !espec.semCerficadoEspec
                              ? []
                              : [!isLogado ? obrigatorio : null]
                          "
                          v-model="espec.justificativa"
                        />
                      </td>
                      <td>
                        <v-tooltip top v-if="espec.valorSelecionado != null">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              @click="
                                espec.valorSelecionado = null;
                                espec.grauInstrucao = null;
                                espec.certificados = null;
                              "
                              icon
                              color="primary"
                              v-bind="attrs"
                              v-on="on"
                            >
                              <i class="fas fa-trash"></i>
                            </v-btn>
                          </template>
                          <span>Limpar</span>
                        </v-tooltip>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>

          <!-- CRO/UF -->
          <v-col md="12" sm="12" cols="12">
            <v-card class="mx-auto" outlined>
              <v-card-text>
                <v-row>
                  <v-col md="4" sm="4" cols="12">
                    <label class="label-f18"> CRO Dentista </label>
                    <br />
                    <label class="titulo-azul"> *Aceitamos protocolo </label>
                  </v-col>
                  <v-col md="8" sm="8" cols="12">
                    <v-checkbox
                      class="ma-0"
                      v-model="editedItem.semCroDentista"
                      label="Não possuo este documento"
                      color="primary"
                      @input="fieldUpdate"
                      @change="
                        editedItem.justifSemCroDentista = null;
                        editedItem.docCroDentista = null;
                      "
                      hide-details
                    ></v-checkbox>
                  </v-col>
                </v-row>
                <v-row v-show="editedItem.semCroDentista">
                  <v-col md="12" sm="12" cols="12">
                    <v-text-field
                      outlined
                      label="*Justificar a ausência do CRO/UF"
                      placeholder="A solicitação de credenciamento passará por análise e está sujeita a ser reprovada pela ausência deste documento."
                      :rules="
                        editedItem.semCroDentista
                          ? [!isLogado ? obrigatorio : null]
                          : []
                      "
                      v-model="editedItem.justifSemCroDentista"
                    />
                  </v-col>
                </v-row>
                <v-row v-show="!editedItem.semCroDentista">
                  <v-col md="12" sm="12" cols="12">
                    <v-file-input
                      :rules="
                        editedItem.semCroDentista
                          ? []
                          : [
                              !isLogado ? obrigatorioArquivo : null,
                              tamanhoInvalido,
                            ]
                      "
                      accept="image/png, image/jpeg, image/bmp, application/pdf"
                      placeholder="Selecione um PDF ou a(s) foto(s) do documento"
                      label="*Imagem ou PDF do CRO/UF"
                      counter
                      multiple
                      small-chips
                      outlined
                      show-size
                      :disabled="editedItem.semCroDentista"
                      v-model="editedItem.docCroDentista"
                      @change="editedItem.justifSemCroDentista = null"
                    />
                    <v-btn
                      v-if="
                        editedItem.docCroDentista &&
                        editedItem.docCroDentista.length > 0
                      "
                      class="mr-2"
                      @click="abrirModalDocumentos(editedItem.docCroDentista)"
                      color="success"
                      ><i class="fas fa-file-image"></i>&nbsp;Ver
                      documentos</v-btn
                    >
                  </v-col>
                </v-row>
                <v-row v-show="!editedItem.semCroDentista">
                  <v-col md="12" sm="12" cols="12" class="pt-0">
                    <div class="text-subtitle-2">
                      Envie um arquivo no formato JPG, PNG ou PDF com boa
                      qualidade e que esteja legível. O arquivo deve ter no
                      máximo 5MB.
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="normal" @click="close"> Cancelar </v-btn>
            <v-btn color="primary" @click="save">
              <!-- :disabled="!validFormCorpoClinico" -->
              Salvar
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogCorpoClinicoDelete" max-width="500px">
      <v-card>
        <v-card-title class="label-f18" style="justificativa-content: center">
          Deseja mesmo deletar esse item?
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <div class="d-flex justify-end">
            <v-btn color="normal" class="mr-2" @click="closeDelete"
              >Cancelar</v-btn
            >
            <v-btn color="error" @click="deleteItemConfirm">Deletar</v-btn>
            <v-spacer></v-spacer>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogDocumentos" width="70%" height="600px">
      <v-card class="pa-5">
        <v-row v-for="(doc, id) in listaDocumentosThumbnail" :key="'Doc' + id">
          <v-col cols="12">
            <embed :src="doc" width="100%" height="auto" />
          </v-col>
        </v-row>

        <v-card-actions>
          <v-btn color="green darken-1" text @click="dialogDocumentos = false">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogEtapaFinalizada" max-width="410">
      <v-card>
        <v-card-title class="text-h5"> Sucesso </v-card-title>
        <v-card-text>
          <p style="font-weight: bold">A indicação foi gerada</p>
          <p></p>
          <p>
            Os dados complementares foram habilitados para preenchimento dos
            dados bancários, documentos e corpo clínico.
          </p>
          <p>
            <span style="font-weight: bold">Etapa: </span>
            {{ etapa }}
          </p>
          <p>
            <span style="font-weight: bold">Perfil: </span>
            {{ perfil }}
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="dialogEtapaFinalizada = false"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogPreencherPasso5" max-width="400">
      <v-card>
        <v-card-title class="label-f18"
          ><i
            class="fas fa-exclamation-circle"
            style="font-size: 32px; color: red"
          ></i>
          <span class="pl-2">Atenção</span></v-card-title
        >
        <v-card-text class="pb-0 pt-2">
          <p class="font-weight-regular mb-0" style="color: #000">
            Confira se todos os dados foram preenchidos corretamente em todas
            as abas. Caso encontre algum campo em branco, complete com as informações
            necessárias. Na quinta aba, "Dados Complementares", anexe os documentos 
            obrigatórios e, em seguida, clique em "Finalizar".
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="dialogPreencherPasso5 = false"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogPEP" max-width="400">
      <v-card>
        <v-card-title class="label-f18"> <span>PEP</span></v-card-title>
        <v-card-text class="pb-0 pt-2">
          <p class="font-weight-regular mb-0" style="color: #000">
            Consideram-se pessoas politicamente expostas os agentes públicos que
            desempenham ou tenham desempenhado, nos cinco anos anteriores, no
            Brasil ou em países, territórios e dependências estrangeiras,
            cargos, empregos ou funções públicas relevantes, assim como seus
            representantes, familiares e estreitos colaboradores.
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="dialogPEP = false">
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-main>
</template>

<script>
import { debounce } from 'debounce';
import vueDropzone from 'vue2-dropzone';
import { cpf } from 'cpf-cnpj-validator';
import moment from 'moment';

export default {
  name: 'BancoIndicacoes',
  data() {
    return {
      alvaraDisabled: false,
      passoAtual: 1,
      respTab: null,
      reprTab: null,
      validou1: false,
      validStep1: true,
      validStep2: true,
      validStep3: true,
      validStep4PF: true,
      validStep4PJ: true,
      validStep5: true,
      validFormCorpoClinico: false,
      servicoBancoIndicacao: '/indicacao',
      servicoEndereco: '/endereco',
      especialidade: {},
      eqpto: null,
      mensagem: '',
      formData: { passo1: {}, passo2: {}, passo3: {}, passo4: {} },
      errorMessage: '',
      documentPath: null,
      cepValido: false,
      buscandoCep: false,
      msg: '',
      msgEndDent: '',
      dialog: false,
      dialogDelete: false,
      dialogAlterarEspec: false,
      dialogCorpoClinico: false,
      dialogCorpoClinicoDelete: false,
      dialogDocumentos: false,
      dialogEtapaFinalizada: false,
      dialogPreencherPasso5: false,
      dialogPEP: false,
      componentKey: 0,
      listaImagensRetorno: [],
      listaDocumentos: [],
      listaDocumentosThumbnail: [],
      etapa: '',
      perfil: '',
      letras: (v) =>
        v == null ||
        v?.length == 0 ||
        v?.match(/^[a-zA-Z ]+$/) ||
        'Campo não pode conter caracter especial ou número!',
      letrasPf: v =>
        v == null ||
        v.length === 0 ||
        /^[A-Za-z\s]+$/.test(v) ||
        'Campo não pode conter caracter especial, número e acento!',
      letrasPj: v =>
        v == null ||
        v.length === 0 ||
        /^[A-Za-z0-9& ]+$/.test(v) ||
        'Campo não pode conter caracter especial (Exceto &) e acento!',
      obrigatorio: (v) => !!v || 'Preenchimento obrigatório',
      obrigatorioArquivo: (v) =>
        (!!v && v.length > 0) || 'É obrigatório selecionar ao menos um arquivo',
      emailValido: (v) =>
        !v || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || 'O e-mail é inválido',
      tamanhoInvalido: (files) =>
        !files ||
        !files.some((file) => file.size > 5e6) ||
        'Documento deve ser menor que 5 MB!',
      croValido: (v) =>
        !v || /^[0-9]{2,7}(?:\/)[A-Z]{2}$|^\/$/.test(v) || 'O CRO é inválido',
      checkCroConsultorio: (v) =>
        !v ||
        !(v.length > 3 && v.split('/')[1] != this.formData.passo1.estado) ||
        'O CRO não corresponde a UF do consultório',
      checkCroConsultorioEpao: (v) =>
        !v ||
        !(v != this.formData.passo1.estado) ||
        'O CRO não corresponde a UF do consultório',
      telefoneValido: (v) =>
        !v ||
        /^\s?(?:\()[0-9]{2}(?:\))\s?[0-9]{4,5}(?:-)[0-9]{4}$/.test(v) ||
        'O número é inválido',
      dataValida: (v) =>
        v == null ||
        v?.length == 0 ||
        moment(v, 'DD/MM/YYYY', true).isValid() ||
        'A data é inválida',
      horaValida: (v) =>
        v == null ||
        v?.length == 0 ||
        moment(v, 'HH:mm', true).isValid() ||
        'A hora é inválida',
      checaInssIsValido: (v) =>
        v == null || v?.length == 0 || this.checaPIS(v) || 'INSS inválido',
      checaDataFormaturaIsValida: (v) =>
        v == null ||
        v?.length == 0 ||
        this.validaDataFormatura() ||
        'As datas de formatura e nascimento são incompatíveis, favor verificar o preenchimento das duas datas',
      checaNomeAbreviado: (v) =>
        v == null ||
        v?.length == 0 ||
        this.validaNomeAbreviado(v) ||
        'Não é permitido digitar o nome abreviado.',
      regrasCep: [this.obrigatorio, this.exact(9)],
      regrasCpf: [
        (v) => !!v || 'O CPF é obrigatório',
        (v) => v?.length <= 14 || 'O CPF deve ter menos de 14 caracteres',
        (v) => cpf.isValid(v) || 'O CPF é inválido',
      ],
      cepInvalido: false || 'CEP inválido',
      listaEstados: [
        'AC',
        'AL',
        'AM',
        'AP',
        'BA',
        'CE',
        'DF',
        'ES',
        'GO',
        'MA',
        'MG',
        'MS',
        'MT',
        'PA',
        'PB',
        'PE',
        'PI',
        'PR',
        'RJ',
        'RN',
        'RO',
        'RR',
        'RS',
        'SC',
        'SE',
        'SP',
        'TO',
      ],
      listaQtdSalas: [
        { codigo: '0', valor: '0' },
        { codigo: '1', valor: '1' },
        { codigo: '2', valor: '2' },
        { codigo: '3', valor: '3' },
        { codigo: '4', valor: '4' },
        { codigo: '5', valor: '5' },
        { codigo: '6', valor: '6' },
        { codigo: '7', valor: '7' },
        { codigo: '8', valor: '8' },
        { codigo: '9', valor: '9' },
        { codigo: '10', valor: '10' },
        { codigo: '11', valor: 'Mais de 10' },
      ],
      listaConservacaoEquip: [
        { codigo: 'Boa', valor: 'Boa' },
        { codigo: 'Regular', valor: 'Regular' },
        { codigo: 'Deficiente', valor: 'Em fase de troca' },
      ],
      listaVentilacao: ['Nenhuma', 'Ventilador', 'Ar condicionado'],
      listaSoftGestao: [
        { codigo: 'E', valor: 'Easy Dental OdontoPrev' },
        { codigo: 'O', valor: 'Outro' },
      ],
      listaRaioX: [
        { codigo: 'N', valor: 'Não Tenho' },
        { codigo: 'C', valor: 'Convencional' },
        { codigo: 'D', valor: 'Digital' },
        { codigo: 'E', valor: 'Em Manutenção' },
      ],
      listaCamera: [
        { codigo: 'C', valor: 'Convencional' },
        { codigo: 'I', valor: 'Intra Oral' },
        { codigo: 'T', valor: 'Celular (Para usar APP)' },
      ],
      listaTipoImovel: [
        'Sobrado/sobreloja',
        'Prédio Comercial',
        'Shopping/Galeria',
        'Casa Térrea',
      ],
      listaEstacionamento: [
        'Próprio gratuito',
        'Próprio pago',
        'Próximo gratuito',
        'Próximo pago',
      ],
      listaTipoEscritorio: [
        { codigo: 'dc', valor: 'Dentro do consultório' },
        { codigo: 'ss', valor: 'Sala separada' },
      ],
      listaRacaCor: [
        { codigo: 1, valor: 'Branca' },
        { codigo: 2, valor: 'Negra' },
        { codigo: 3, valor: 'Parda' },
        { codigo: 4, valor: 'Amarela' },
        { codigo: 5, valor: 'Indígena' },
      ],
      listaPais: [{ codigo: 1, valor: 'Brasil' }],
      listaEquipamentos: [
        'Autoclave',
        'Bisturi',
        'CAD/CAM',
        'Fresadora',
        'Impressora 3D',
        'Laser - Alta potência',
        'Laser - Baixa potência',
        'Microscópio Óptico (Endodontia)',
        'Oxido Nitroso (Sedação)',
        'Scanner intraoral',
        'Sistema Rotatório (Endodontia)',
        'Aparelho de Tomógrafo linear (Radiológica)',
        'Tomógrafo Computadorizado (Radiológica)',
        'Ultrassom',
      ],
      especialidadesGeral: this.$const.especialidadesGeral,
      listaGrauInstrucao: this.$const.listaGrauInstrucao,
      dropOptions: {
        url: '/upload',
        parallelUploads: 1,
        autoProcessQueue: true,
        addRemoveLinks: true,
        acceptedFiles: 'image/jpg, image/jpeg, image/png, application/pdf',
        maxFilesize: 5, //mb
        filesizeBase: 5000,
        maxNumberOfFiles: 6,
        capture: 'image/jpg, image/jpeg, image/png',
        resizeQuality: 0.5,
        thumbnail: function (file, dataUrl) {
          if (file.previewElement) {
            file.previewElement.classList.remove('dz-file-preview');
            var images = file.previewElement.querySelectorAll(
              '[data-dz-thumbnail]'
            );
            for (var i = 0; i < images.length; i++) {
              var thumbnailElement = images[i];
              thumbnailElement.alt = file.name;
              thumbnailElement.src = dataUrl;
            }
            setTimeout(function () {
              file.previewElement.classList.add('dz-image-preview');
            }, 1);
          }
        },
        dictDefaultMessage:
          '<div class="text-subtitle-2">Arraste e solte, ou clique aqui para enviar um arquivo no formato JPG, PNG ou PDF com boa qualidade e que esteja legível. <br> O arquivo deve ter no máximo 5MB<div>',
        dictFallbackMessage:
          'Seu navegador não suporta arrastar e soltar arquivos.',
        dictFallbackText:
          'Use o formulário de fallback abaixo para fazer upload de seus arquivos como nos velhos tempos.',
        dictFileTooBig:
          'Arquivo muito grande ({{filesize}}MB). Tamanho máximo: {{maxFilesize}}MB.',
        dictInvalidFileType:
          'Você não pode fazer upload de arquivos desse tipo.',
        dictResponseError: 'O servidor respondeu com o código {{statusCode}}.',
        dictCancelUpload: 'Cancelar upload',
        dictUploadCanceled: 'Upload cancelado.',
        dictCancelUploadConfirmation:
          'Tem certeza de que deseja cancelar este upload?',
        dictRemoveFile: 'Remover imagem',
        dictMaxFilesExceeded: 'Número máximo de arquivos atingido.',
      },
      headers: [
        { text: 'Nome', align: 'start', sortable: false, value: 'name' },
        { text: 'CRO/UF', value: 'cro' },
        { text: 'Data de nascimento', value: 'dataNasc' },
        { text: 'RG', value: 'rg' },
        { text: 'CPF', value: 'cpf' },
        { text: 'Faculdade', value: 'faculdade' },
        { text: 'Ações', value: 'actions', sortable: false },
      ],
      editedIndex: -1,
      editedItem: {
        name: '',
        cro: '',
        dataNasc: '',
        rg: '',
        cpf: '',
        sexo: '',
        faculdade: '',
        dataFormatura: '',
        especialidades: [],
        docCroDentista: null,
        justificativaCroDentista: '',
      },
      defaultItem: {
        name: '',
        cro: '',
        dataNasc: '',
        rg: '',
        cpf: '',
        sexo: '',
        faculdade: '',
        dataFormatura: '',
        especialidades: [],
        docCroDentista: null,
        justificativaCroDentista: '',
      },
      nomeBloqueado: false,
      sexoBloqueado: false,
      nrCpfBloqueado: false,
      rgBloqueado: false,
      dataNascBloqueado: false,
      emailBloqueado: false,
    };
  },
  components: {
    vueDropzone,
  },
  computed: {
    checkCamposNascNaoObrigatorio() {
      return (
        (this.isLogado || this.formData.passo4.paisNasc != 1) &&
        (this.formData.passo4.paisNasc == null ||
          this.formData.passo4.paisNasc != 1)
      );
    },
    isLogado() {
      return this.checkIfIsLogged();
    },
    isOculto() {
      return false;
    },
    //Regiao dimensionada -> Verifica se já existe dentista na regiao.
    isDimensionado() {
      return true; //this.formData.cadastroDimensionado || this.isAtualizacao
    },
    isAtualizacao() {
      return (
        this.formData.modalidade == this.$modalidades.ATUALIZACAO_INDICACAO
      );
    },
    isPJ() {
      return this.formData.passo1.tipoDocumento == 'J';
    },
    isRadiologiaOuEmergencia() {
      return (
        this.formData.listaEspecialidades.length == 1 &&
        this.formData.listaEspecialidades.find((x) =>
          [14, 18].includes(x.codigo)
        ) != undefined
      );
    },
    isDocPendente() {
      return this.formData.passoIndic === 'DOC_PENDENTE';
    },
  },
  methods: {
    validarCorpoClinico() {
      // Regra de negócio
      if (
         !this.isRadiologiaOuEmergencia &&
         !this.isDocPendente &&
          this.isPJ
      ) {
        const lista = this.formData.passo5.listaCorpoClinico;

        if (!lista || lista.length === 0) {
          return false;
        }
      }

      return true;
    },
    onCroNumeroInput(val) {
      // filtra somente números
      this.formData.passo4.croClinicaNumeroPf = (val || '').replace(/\D/g, '');
    },
    validaCRORespTec(event) {
      const onlyNumbers = (event.target.value || '').replace(/\D/g, '');
      this.respTec.cro = onlyNumbers;
    },
    onCroInput(val) {
      const prefix = 'EPAO-';
      val = (val || '').toString().toUpperCase();

      // garante que o prefixo nunca seja removido
      if (!val.startsWith(prefix)) {
        // remove tentativas de digitar manualmente o prefixo ou apagar
        val = val.replace(/^EPAO-?/, '');
      } else {
        val = val.slice(prefix.length);
      }

      // filtra caracteres válidos (letras, números e '/')
      let tail = val.replace(/[^A-Z0-9/]/g, '').slice(0, 20);

      // monta o valor final com o prefixo fixo
      this.formData.passo4.croClinicaNumero = prefix + tail;
    },
    blockPrefixDelete(event) {
      const prefix = 'EPAO-';
      const value = this.formData.passo4.croClinicaNumero || '';

      // posição do cursor no input
      const caretPos = event.target.selectionStart;

      // se o cursor estiver dentro do prefixo e a tecla for Backspace ou Delete → bloqueia
      if (
        caretPos <= prefix.length &&
        (event.key === 'Backspace' || event.key === 'Delete')
      ) {
        event.preventDefault();
      }
    },
     onSemDadosBancariosChange() {
    console.log('semDadosBancarios:', this.formData.passo5.semDadosBancarios);
  },

    limparCampos() {
      console.log('Limpando campos...');
      Object.assign(this.formData.passo5, {
        semAlvaraFuncionamento: false,
        semAlvaraVigiSanit: false,
        semCroRespClinica: false,
        semCerficadoEspec: false,
        semContratoSocial: false,
        semCroClinica: false,
        nrAlvaraFuncionamento: "",
        nrAlvaraVigiSanit: "",
        dataEmissaoAlvaraFuncionamento: "",
        dataEmissaoAlvaraVigiSanit: "",
        dataValidadeAlvaraFuncionamento: "",
        dataValidadeAlvaraVigiSanit: "",
        justifSemCroRespClinica: "",
        justifSemCroClinica: "",
        justifSemCro: "",
        justifSemContratoSocial: "",
        justifSemAlvara: "",
        justifSemAlvaraVigiSanit: "",
        banco: null,
        nrAgencia: null,
        nrAgenciaDig: null,
        nrConta: null,
        nrContaDig: null,
        docBancario: null,
      });
    },
    limparCamposEnvioProposta() {
      console.log('Limpando campos token envio de proposta...');
      Object.assign(this.formData.passo5, {
        semCroClinica: false,
        semCro: false,
        semCertificado: false,
        semAlvaraFuncionamento: false,
        semAlvaraVigiSanit: false,
        semCroRespClinica: false,
        semCerficadoEspec: false,
        semContratoSocial: false,
        justifSemCroRespClinica: '',
        justifSemCroClinica: '',
        justifSemCro: '',
        justifSemContratoSocial: '',
        justifSemAlvara: '',
        justifSemAlvaraVigiSanit: '',
        nrAlvaraFuncionamento: '',
        nrAlvaraVigiSanit: '',
        dataEmissaoAlvaraFuncionamento: '',
        dataEmissaoAlvaraVigiSanit: '',
        dataValidadeAlvaraFuncionamento: '',
        dataValidadeAlvaraVigiSanit: '',
      });
    },
    validarTipoArquivo(arquivos) {
      const tiposPermitidos = ['image/jpeg', 'image/png', 'application/pdf'];
      if (!arquivos || arquivos.length === 0) return true;

      for (const arquivo of arquivos) {
        if (!tiposPermitidos.includes(arquivo.type)) {
          return 'Apenas arquivos JPG, PNG ou PDF são permitidos.';
        }
      }

      return true;
    },

    exibirDocPendente(doc) {
      if (this.formData.passoIndic === 'DOC_PENDENTE') {
        return this.formData.emailItens.includes(doc);
      }

      return true;
    },
    handleFileChange(newFiles) {
      if (typeof newFiles !== 'undefined' && newFiles.length > 0) {
        // Filtrando os novos arquivos para evitar duplicação
        const uniqueFiles = newFiles.filter((newFile) => {
          return !this.formData.passo5.certificados.some((existingFile) => {
            return (
              existingFile.name === newFile.name &&
              existingFile.size === newFile.size
            );
          });
        });
        // Atualizando o array de arquivos com os novos arquivos, sem duplicação
        this.formData.passo5.certificados = [
          ...this.formData.passo5.certificados,
          ...uniqueFiles,
        ];
        formData.passo5.semCertificadoEsp = null;
        console.log(newFiles);
      } else {
        this.formData.passo5.certificados = [];
      }
    },
    adicionarNovoDentista() {
      this.dialogCorpoClinico = true;
      this.editedItem.especialidades = JSON.parse(
        JSON.stringify(this.$const.especialidadesGeral)
      );
    },
    validarAcentos(e) {
      if (/[^A-Za-z0-9 ]$/.test(e.key)) {
        e.preventDefault();
      }
    },
    clearAndUpper(text) {
      return text
        .normalize('NFD')
        .replace(/[^A-Za-z0-9& ]/g, '')
        .toUpperCase();
    },
    Upper(text) {
      return text ? text.toUpperCase() : '';
    },
    alterarEspecialidades() {
      var indicacao = {
        cep: this.formData.passo1.cep,
        documento: this.formData.passo1.documento,
        tipoDocumento: this.formData.passo1.tipoDocumento,
        dataNasc: this.isPJ
          ? this.formData.passo4.listaRespTec[0].dataNasc
          : this.formData.passo4.dataNasc,
      };
      this.$router.push({ name: 'Home', params: indicacao });
    },
    checkIfIsLogged() {
      let token = localStorage.getItem('cod_consultor');
      if (token && this.$route.name !== 'login') {
        return true;
      } else {
        return false;
      }
    },
    validarCamposData(atend) {
      return (
        ((atend.saida != null && atend.saida.length > 0) ||
          (atend.entrada != null && atend.entrada.length > 0)) &&
        atend.segunda != true &&
        atend.terca != true &&
        atend.quarta != true &&
        atend.quinta != true &&
        atend.sexta != true &&
        atend.sabado != true &&
        atend.domingo != true
      );
    },
    isAtendimentoValido() {
      var valid = true;
      this.formData.passo3.listaHorariosAtendimento.forEach((atend) => {
        if (this.validarCamposData(atend)) {
          valid = false;
        }
      });
      return valid;
    },
    getRulesHour(horario, atend) {
      return (horario != null && horario.length > 0) ||
        !(
          atend.segunda != true &&
          atend.terca != true &&
          atend.quarta != true &&
          atend.quinta != true &&
          atend.sexta != true &&
          atend.sabado != true &&
          atend.domingo != true
        )
        ? [this.horaValida, this.obrigatorio]
        : [this.horaValida];
    },
    async autoSave() {
      let request = this.formData;
      await this.acertarRequest(request);
      this.$http
        .put(`${this.servicoBancoIndicacao}/atualizar`, request)
        .then(() => {
          this.acertarResponse(request);
        });
    },
    addReprLeg() {
      this.formData.passo4.listaRepreLegal.push({ nome: '' });
      this.reprTab = parseInt(this.formData.passo4.listaRepreLegal.length) - 1;
    },
    addRespTec() {
      this.formData.passo4.listaRespTec.push({
        nome: '',
      });
      this.respTab = parseInt(this.formData.passo4.listaRespTec.length) - 1;
    },
    next() {
      if (this.passoAtual < 4) {
        this.validateStep(this.passoAtual);
        this.passoAtual++;
      } else {
        if (this.passoAtual === 4 && this.isAtualizacao) {
          this.validateStep(this.passoAtual);
          this.passoAtual++;
        } else {
          this.validateStep(-1);
        }
      }
    },
    validateStep(step) {
      if (!this.isAtualizacao) {
        this.autoSave();
      }
      this.formData.passoSelecionado = step;
      this.validou1 = true;
      this.updateLocalStorage();

      switch (step) {
        case 1:
          break;
        case 2:
          this.$refs.form1.validate();
          break;
        case 3:
          this.$refs.form1.validate();
          this.$refs.form2.validate();
          break;
        case 4:
          this.$refs.form1.validate();
          this.$refs.form2.validate();
          this.$refs.form3.validate();
          break;
        case 5:
          this.$refs.form1.validate();
          this.$refs.form2.validate();
          this.$refs.form3.validate();
          if (this.isPJ) {
            this.validStep4PJ = this.$refs.form4PJ.validate();
          } else {
            this.validStep4PF = this.$refs.form4PF.validate();
          }
          break;
        default:
          if (step == -1) {
            if (
              this.isAtualizacao &&
              this.formData.passoIndic === 'DOC_PENDENTE'
            ) {
              if (this.$refs.form5.validate()) {
                this.finalizarAtualizacao();
              } else {
                this.mostrarModalErro();
                return;
              }
            }

            this.$refs.form1.validate();
            this.$refs.form2.validate();
            this.$refs.form3.validate();
            if (this.isPJ) {
              this.validStep4PJ = this.$refs.form4PJ.validate();
            } else {
              this.validStep4PF = this.$refs.form4PF.validate();
            }

            if (
              this.isAtualizacao &&
              this.formData.passoIndic !== 'DOC_PENDENTE'
            ) {
              this.$refs.form5.validate();
              if (
                this.validStep1 &&
                this.validStep2 &&
                this.validStep3 &&
                this.isAtendimentoValido() &&
                (this.isPJ ? this.validStep4PJ : this.validStep4PF) &&
                this.validStep5 &&
                this.validarCorpoClinico()
              ) {
                this.finalizarAtualizacao();
              } else {
                this.mostrarModalErro();
                console.log("Caiu no modal de erro");
              }
            } else if (this.formData.passoIndic !== 'DOC_PENDENTE') {
              if (
                this.validStep1 &&
                this.validStep2 &&
                this.validStep3 &&
                this.isAtendimentoValido() &&
                (this.isPJ ? this.validStep4PJ : this.validStep4PF)
              ) {
                this.finalizarEtapa1Indicacao();
              } else {
                this.mostrarModalErro();
              }
            }
          }
      }
    },
    mostrarModalErro() {
      if (this.isAtualizacao && this.formData.passoIndic === 'DOC_PENDENTE') {
        this.msg = 'Erro encontrado na(s) etapa(s): </br></br><strong><ul>';
        this.msg += '<li>Dados Complementares</li>';
      } else if(!this.validarCorpoClinico()){
         this.msg = '<strong>É obrigatório adicionar pelo menos um profissional no Corpo Clínico.</strong></br>';
      }else {
        this.msg =
          'Erro encontrado na(s) etapa(s): </br></br><strong><ul>' +
          (this.validStep1 ? '' : '<li>Endereço do Consultório</li>') +
          (this.validStep2 ? '' : '<li>Dados do Consultório</li>') +
          (this.validStep3 && this.isAtendimentoValido()
            ? ''
            : '<li>Atendimento</li>') +
          (this.validStep4PF && this.validStep4PJ
            ? ''
            : '<li>Dados do Dentista</li>');
        if (this.isAtualizacao || !this.validFormCorpoClinico) {
          this.msg += this.validStep5 ? '' : '<li>Dados Complementares</li>';
        }
      }

      this.msg +=
        '</ul></strong></br>Acerte os dados para finalizar o cadastro';

      this.dialog = true;
    },
    exact(i) {
      return (v) => v?.length == i || 'O campo deve ter ' + i + ' caracteres';
    },
    forceRerender() {
      this.componentKey += 1;
    },
    async updateLocalStorage() {
      try {
        localStorage.setItem(this.documentPath, JSON.stringify(this.formData));
      } catch (error) {
        this.errorMessage = JSON.stringify(error);
      }
    },
    fieldUpdate() {
      this.debouncedUpdate();
    },
    debouncedUpdate: debounce(function () {
      this.updateLocalStorage();
    }, 3000),
    buscarCidades(uf, origem) {
      this.$eventBus.$emit(this.$const.EVENT_SHOW_LOADING);
      if (this.formData.passo4.listaRespTec) {
        this.formData.passo4.listaRespTec.forEach(function (item) {
          item.msgEndRespTec = '';
        });
      }
      this.$http
        .get(`${this.servicoEndereco}/cidade?uf=` + uf)
        .then((response) => {
          switch (origem) {
            case 0:
              this.formData.passo4.listaCidades = response.data;
              break;
            default:
              this.formData.passo4.listaRespTec[origem - 1].listaCidades =
                response.data;
              break;
          }
        })
        .catch((error) => {
          switch (origem) {
            case 0:
              this.formData.passo4.listaCidades = [];
              break;
            default:
              this.formData.passo4.listaRespTec[origem - 1].listaCidades = [];
              break;
          }
        })
        .then(() => {
          this.forceRerender();
          this.$eventBus.$emit(this.$const.EVENT_REMOVE_LOADING);
        });
    },
    buscarCidadesNasc(uf) {
      this.$eventBus.$emit(this.$const.EVENT_SHOW_LOADING);
      this.$http
        .get(`${this.servicoEndereco}/cidade-ibge?uf=` + uf)
        .then((response) => {
          this.formData.passo4.listaCidadesNasc = response.data;
        })
        .catch((error) => {
          this.formData.passo4.listaCidadesNasc = [];
        })
        .then(() => {
          this.forceRerender();
          this.$eventBus.$emit(this.$const.EVENT_REMOVE_LOADING);
        });
    },
    buscarPaises() {
      this.$http.get(`${this.servicoEndereco}/pais`).then((response) => {
        this.listaPais = response.data;
      });
    },
    async finalizarAtualizacao() {
      let request = this.formData;

      this.preencherDadosBancoDefault();

      const arquivos = [
        'docBancario',
        'docCroClinica',
        'docCro',
        'docCroRespClinica',
        'docContratoSocial',
        'docAlvara',
        'docAlvaraVigiSanit',
        'docContratoDocusign',
        'certificados',
      ];

      for (const arquivo of arquivos) {
        try {
          request.passo5[arquivo] = await this.converterArquivosBase64(
            this.formData.passo5[arquivo]
          );
          console.log(`${arquivo}: imagem recebida e convertida com sucesso.`);
        } catch (error) {
          console.error(`${arquivo}: falha na conversão.`, error);
        }
      }
      request.passo5.semCerficadoEspec = this.formData.passo5.semCerficadoEspec;

      //converte os documentos do corpo clinico em base64 para envio da request
      for (var i = 0; i < request.passo5.listaCorpoClinico.length; i++) {
        request.passo5.listaCorpoClinico[i].docCroDentista =
          await this.converterArquivosBase64(
            request.passo5.listaCorpoClinico[i].docCroDentista
          );

        for (
          var y = 0;
          y < request.passo5.listaCorpoClinico[i].especialidades.length;
          y++
        ) {
          var item =
            request.passo5.listaCorpoClinico[i].especialidades[y].certificados;

          item = item ? await this.getBase64(item) : null;

          if (item) {
            request.passo5.listaCorpoClinico[i].especialidades[y].certificados =
              [];

            request.passo5.listaCorpoClinico[i].especialidades[
              y
            ].certificados.push(item.split('base64,')[1]);
          }

          request.passo5.listaCorpoClinico[i].especialidades[y].certificado =
            '';
        }
      }

      request.modalidade = this.$modalidades.INDICACAO_FINALIZADA;

      this.$eventBus.$emit(this.$const.EVENT_SHOW_LOADING);
      this.acertarRequest(request);

      this.$http
        .put(`${this.servicoBancoIndicacao}/atualizar`, request)
        .then(() => {
          this.$eventBus.$emit(this.$const.EVENT_REMOVE_LOADING);

          this.$router.push({
            name: 'FeedbackIndicacaoFinalizada',
            params: { decription: 'Indicação Finalizada!' },
          });
        })
        .catch((error) => {
          this.$eventBus.$emit(this.$const.EVENT_REMOVE_LOADING);
        });
    },
    async finalizarEtapa1Indicacao() {

      if (this.isPJ) {
        this.formData.passo4.listaRespTec.forEach(item => {
          if (!item.cro || !item.uf) {
            throw new Error("CRO e UF são obrigatórios para responsável técnico PJ");
          }
          item.cro = `${item.cro}/${item.uf}`;
          console.log(item.cro);
        });
      }
      
      this.formData.passo4.croClinica = `${this.formData.passo4.croClinicaNumero}/${this.formData.passo4.ufClinica}`;

      this.formData.passo4.cro = `${this.formData.passo4.croClinicaNumeroPf}/${this.formData.passo4.ufClinicaPf}`;

      this.preencherDadosBancoDefault();

      this.formData.passo5.nrAlvaraFuncionamento =
        this.formData.passo1.alvaraFunc;
      this.formData.passo5.nrAlvaraVigiSanit =
        this.formData.passo1.nrVigilanciaSanitaria;

      let request = this.formData;

      let dataNasc = '';
      if (this.formData.passo4.listaRespTec) {
        dataNasc = this.formData.passo4.listaRespTec[0].dataNasc;
      } else {
        dataNasc = this.formData.passo4.dataNasc;
      }

      request.passoSelecionado = -1;
      await this.acertarRequest(request);
      this.$eventBus.$emit(this.$const.EVENT_SHOW_LOADING);
      this.$http
        .put(`${this.servicoBancoIndicacao}/atualizar`, request)
        .then(() => {
          this.$http
            .post(
              `${this.servicoBancoIndicacao}/finalizar-etapa1?documento=` +
                this.formData.passo1.documento +
                `&cep=` +
                this.formData.passo1.cep +
                `&dataNasc=` +
                dataNasc
            )
            .then((response) => {
              const nomeDentista = this.isPJ
                ? request.passo4.listaRespTec[0].nome
                : request.passo4.nomeDentista;
              const resultado = {
                result: response.data.resultado,
                nomeDentista: nomeDentista,
                nrIndicacao: response.data.nrIndicacao,
                cidade: request.passo1.cidade.nome,
              };
              if (this.isLogado) {
                console.log('Entrou aqui no logado');
                this.formData.modalidade =
                  this.$modalidades.ATUALIZACAO_INDICACAO;
                this.formData.resultadoFinalizarPasso4 = resultado;
                this.etapa = response.data.etapa;
                this.perfil = response.data.perfil;
                this.dialogEtapaFinalizada = true;
              } else {
                this.$router.push({
                  name: 'FeedbackPrimeiraEtapa',
                  params: resultado,
                });
              }

              this.bloquearCamposPreenchidos();
            })
            .catch((error) => {
              if (error.response.data.message) {
                this.mensagem = error.response.data.message;
              } else {
                this.mensagem = this.$msg.ERRO_INTERNO;
              }
            })
            .then(() => {
              this.acertarResponse(request);
              this.$eventBus.$emit(this.$const.EVENT_REMOVE_LOADING);
            });
        })
        .catch((error) => {
          this.$eventBus.$emit(this.$const.EVENT_REMOVE_LOADING);
          if (error.response?.data.message) {
            this.mensagem = error.response.data.message;
          } else {
            this.mensagem = this.$msg.ERRO_INTERNO;
          }
        });
    },
    async acertarRequest(request) {
      if (this.listaImagensRetorno.length > 0) {
        request.passo2.imagensConsultorio = [];
        request.passo2.imagensConsultorio = this.listaImagensRetorno.filter(
          (obj) => obj.uuid != null
        );
        this.listaImagensRetorno.forEach(function (obj) {
          obj.uuid = null;
        });
        this.$refs.myVueDropzone.dropzone.removeAllFiles(true);
      }
      if (
        this.formData.passo4.tipoLogradouro &&
        !this.formData.passo4.tipoLogradouro.codigo
      ) {
        request.passo4.tipoLogradouro =
          request.passo1.listaTipoLogradouros.find(
            (x) => x.codigo === request.passo4.tipoLogradouro
          );
      }
      if (this.formData.passo1.bairro && !this.formData.passo1.bairro.codigo) {
        request.passo1.bairro = request.passo1.listaBairros.find(
          (x) => x.codigo === request.passo1.bairro
        );
      }
      if (
        this.formData.passo1.tipoLogradouro &&
        !this.formData.passo1.tipoLogradouro.codigo
      ) {
        request.passo1.tipoLogradouro =
          request.passo1.listaTipoLogradouros.find(
            (x) => x.codigo === request.passo1.tipoLogradouro
          );
      }
    },
    preencherDadosBancoDefault() {
      if (!this.formData.passo5.banco) {
        this.formData.passo5.banco = null;
        this.formData.passo5.nrAgencia = '0000';
        this.formData.passo5.nrAgenciaDig = '0';
        this.formData.passo5.nrConta = '0';
        this.formData.passo5.nrContaDig = '0';
      }
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    async converterArquivosBase64(list) {
      if (list && typeof list[0] === 'object') {
        var files = list;
        var listBase64 = [];

        for (var i = 0; i < files?.length; i++) {
          var base64 = await this.getBase64(files[i]);
          listBase64.push(base64);
        }

        return listBase64;
      }
      return list;
    },
    acertarResponse(request) {
      if (this.formData.passo1.bairro && this.formData.passo1.bairro.codigo) {
        this.formData.passo1.bairro = request.passo1.bairro.codigo;
      }
      if (
        this.formData.passo1.tipoLogradouro &&
        this.formData.passo1.tipoLogradouro.codigo
      ) {
        this.formData.passo1.tipoLogradouro =
          request.passo1.tipoLogradouro.codigo;
      }
    },
    buscarCEP(cep, origem) {
      this.msgEndDent = '';
      if (this.formData.passo4.listaRespTec) {
        this.formData.passo4.listaRespTec.forEach(function (item) {
          item.msgEndRespTec = '';
        });
      }
      if (cep.length === 9) {
        const rawCep = cep.replaceAll('-', '');
        this.$eventBus.$emit(this.$const.EVENT_SHOW_LOADING);
        this.$http
          .get(`${this.servicoEndereco}/cep?cep=` + rawCep)
          .then((response) => {
            switch (origem) {
              case 0:
                this.formData.passo4.listaCidades = response.data.listaCidades;
                this.formData.passo4.erEndereco =
                  response.data.endereco.logradouro;
                this.formData.passo4.erEstado = response.data.endereco.estado;
                this.formData.passo4.erCidade = response.data.cidade;
                this.formData.passo4.tipoLogradouro =
                  response.data.endereco.cdTipoLogradouro;
                this.formData.passo4.desabilitarEndereco = true;
                break;
              default:
                this.formData.passo4.listaRespTec[origem - 1].listaCidades =
                  response.data.listaCidades;
                this.formData.passo4.listaRespTec[origem - 1].ecEndereco =
                  response.data.endereco.logradouro;
                this.formData.passo4.listaRespTec[origem - 1].ecEstado =
                  response.data.endereco.estado;
                this.formData.passo4.listaRespTec[origem - 1].ecCidade =
                  response.data.cidade;
                this.formData.passo4.listaRespTec[
                  origem - 1
                ].desabilitarEndereco = true;
                this.formData.passo4.listaRespTec[origem - 1].listaBairros =
                  response.data.listaBairros;
                this.formData.passo4.listaRespTec[origem - 1].bairro =
                  response.data.bairro;
            }
            this.listaCidades = response.data;
          })
          .catch((error) => {
            switch (origem) {
              case 0:
                this.formData.passo4.desabilitarEndereco = false;
                this.formData.passo4.listaCidades = [];
                this.formData.passo4.erEstado = null;
                this.formData.passo4.erEndereco = null;
                this.formData.passo4.erCidade = null;
                this.formData.passo4.tipoLogradouro = null;
                if (error.response.data.message) {
                  this.msgEndDent = error.response.data.message;
                } else {
                  this.msgEndDent = this.$msg.ERRO_INTERNO;
                }
                break;
              default:
                this.formData.passo4.listaRespTec[
                  origem - 1
                ].desabilitarEndereco = false;
                this.formData.passo4.listaRespTec[origem - 1].listaCidades = [];
                this.formData.passo4.listaRespTec[origem - 1].ecEstado = null;
                this.formData.passo4.listaRespTec[origem - 1].ecEndereco = null;
                this.formData.passo4.listaRespTec[origem - 1].ecCidade = null;
                if (error.response.data.message) {
                  this.formData.passo4.listaRespTec[origem - 1].msgEndRespTec =
                    error.response.data.message;
                } else {
                  this.formData.passo4.listaRespTec[origem - 1].msgEndRespTec =
                    this.$msg.ERRO_INTERNO;
                }
                break;
            }
          })
          .then(() => {
            this.forceRerender();
            this.$eventBus.$emit(this.$const.EVENT_REMOVE_LOADING);
          });
      }
    },

    checaPIS(pis) {
      var ftap = '3298765432';
      var total = 0;
      var i;
      var resto = 0;
      var numPIS = pis;
      var strResto = '';
      var resultado;
      if (numPIS == '' || numPIS == null) {
        return false;
      } else if (numPIS.length != 11) {
        return false;
      }
      for (i = 0; i <= 9; i++) {
        resultado = numPIS.slice(i, i + 1) * ftap.slice(i, i + 1);
        total = total + resultado;
      }
      resto = total % 11;
      if (resto != 0) {
        resto = 11 - resto;
      }
      if (resto == 10 || resto == 11) {
        strResto = resto + '';
        resto = strResto.slice(1, 2);
      }
      if (resto != numPIS.slice(10, 11)) {
        return false;
      }
      return true;
    },

    validaDataFormatura() {
      var dataNasc = this.isPJ
        ? this.formData.passo4.listaRepreLegal[0].dataNasc
        : this.formData.passo4.dataNasc;
      const dataFormatura = this.formData.passo4.dataFormatura;
      if (
        dataNasc != null &&
        dataNasc.length === 10 &&
        dataFormatura != null &&
        dataFormatura.length === 10
      ) {
        var from = dataNasc.split('/');
        var to = dataFormatura.split('/');
        var dt_nascimento = new Date(from[2], from[1] - 1, from[0]);
        var dt_formatura = new Date(to[2], to[1] - 1, to[0]);
        var dt_corrente = new Date();

        var anoDtNascimento = dt_nascimento.getFullYear() + 1;
        var anoDtFormatura = dt_formatura.getFullYear() + 1;

        var totalAno = anoDtFormatura - anoDtNascimento;

        if (totalAno < 18 || anoDtFormatura > dt_corrente.getFullYear()) {
          return false;
        }
      }
      return true;
    },

    validaNomeAbreviado(nome) {
      var resp = true;
      if (nome == null || nome.trim() === '') {
        return resp;
      }
      var nomeCompleto = nome.trim().split(' ');
      nomeCompleto.forEach(function (pedacoNome) {
        pedacoNome = pedacoNome.trim();
        if (pedacoNome != '') {
          if (pedacoNome.length <= 1 && pedacoNome.toUpperCase() != 'E') {
            resp = false;
          }
        }
      });
      return resp;
    },

    removedFile(file) {
      var removeIndex = this.listaImagensRetorno
        .map((item) => item.uuid)
        .indexOf(file.upload.uuid);
      ~removeIndex && this.listaImagensRetorno.splice(removeIndex, 1);
    },
    initialize() {},

    editItem(item) {
      this.editedIndex = this.formData.passo5.listaCorpoClinico.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogCorpoClinico = true;
    },

    deleteItem(item) {
      this.editedIndex = this.formData.passo5.listaCorpoClinico.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogCorpoClinicoDelete = true;
    },

    deleteItemConfirm() {
      this.formData.passo5.listaCorpoClinico.splice(this.editedIndex, 1);
      this.closeDelete();
    },

    close() {
      this.dialogCorpoClinico = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogCorpoClinicoDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    montarPayload() {
      // normaliza e concatena apenas se houver UF
      const cro = (this.editedItem.cro || '').toString().trim();
      const uf = (this.editedItem.uf || '').toString().trim().toUpperCase();

      const croComUf = (cro && uf) ? `${cro}/${uf}` : cro;

      // retorna um novo objeto (não modifica editedItem)
      return {
        ...this.editedItem,
        cro: croComUf
      };
    },
    save() {
      if (this.$refs.formCorpoClinico.validate()) {


        const payload = this.montarPayload();
        if (this.editedIndex > -1) {
          Object.assign(
            this.formData.passo5.listaCorpoClinico[this.editedIndex],
            payload
          );
        } else {
          this.formData.passo5.listaCorpoClinico.push(payload);
        }
        this.close();
      } else {
        this.mostrarModalErro();
      }
    },

    async abrirModalDocumentos(documentos) {
      this.listaDocumentosThumbnail = [];

      this.listaDocumentosThumbnail = await this.converterArquivosBase64(
        documentos
      );

      this.dialogDocumentos = true;
    },

    bloquearCamposPreenchidos() {
      if (this.isAtualizacao && this.formData.passo4.listaRepreLegal) {
        if (this.formData.passo4.listaRepreLegal[0].nome) {
          this.nomeBloqueado = true;
        }
        if (this.formData.passo4.listaRepreLegal[0].sexo) {
          this.sexoBloqueado = true;
        }
        if (this.formData.passo4.listaRepreLegal[0].nrCpf) {
          this.nrCpfBloqueado = true;
        }
        if (this.formData.passo4.listaRepreLegal[0].rg) {
          this.rgBloqueado = true;
        }
        if (this.formData.passo4.listaRepreLegal[0].dataNasc) {
          this.dataNascBloqueado = true;
        }
        if (this.formData.passo4.listaRepreLegal[0].email) {
          this.emailBloqueado = true;
        }
      }
    },
  },
  watch: {
    dialogCorpoClinico(val) {
      val || this.close();
    },
    dialogCorpoClinicoDelete(val) {
      val || this.closeDelete();
    },
  },
  created: function () {
    if (Object.keys(this.$route.params).length !== 0) {
      this.documentPath =
        this.$const.documentPath +
        this.$route.params.passo1.documento.replace(/\D/g, '') *
          this.$const.number;
    } else {
      this.$router.push('/');
    }
    this.formData = this.$route.params;

    //Buscar cidades na api de serviço de endereço
    //para que fique em conformidade com a tabela TBOD_MUNICIPIO
    this.buscarCidadesNasc(this.formData.passo4.ufNasc);

    //Retira Banco "999 - Outros"
    this.formData.passo5.listaBancos = this.formData.passo5.listaBancos.filter(
      (q) => q.codigo != 999
    );

    this.listaImagensRetorno = [];
    this.listaImagensRetorno = this.formData.passo2.imagensConsultorio;
    this.formData.passo2.imagensConsultorio = [];
    this.passoAtual = this.formData.passoAtual;

    if (this.passoAtual == 5 && this.formData.passoIndic !== 'DOC_PENDENTE') {
      this.passoAtual = 1;
      this.dialogPreencherPasso5 = true;
    }

    if (this.isAtualizacao && !this.isLogado) {
      this.formData.passoAtual = 4;
    }

    setTimeout(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }, 300);
  },
  mounted: function () {

    if (!this.formData.passo4.croClinicaNumero && this.isPJ) {
      this.formData.passo4.croClinicaNumero = 'EPAO-';
    }

    this.buscarPaises();

    const toBase64 = (file) =>
      new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });

    async function getBase64(file, vue, uploadObject) {
      uploadObject.emit('uploadprogress', file, 30, file.upload.bytesSent);
      var base64 = await toBase64(file);
      setTimeout(function () {
        uploadObject.emit('uploadprogress', file, 60, file.upload.bytesSent);
        setTimeout(function () {
          uploadObject.emit('uploadprogress', file, 100, file.upload.bytesSent);
          file.status = 'success';
          uploadObject.emit('success', file, 'success', null);

          vue.listaImagensRetorno.push({
            uuid: file.upload.uuid,
            base64: base64,
            filename: file.upload.filename,
          });
          uploadObject.processQueue();
        }, 300);
      }, 300);
    }

    const vue = this;
    this.$refs.myVueDropzone.dropzone.uploadFiles = function (files) {
      var self = this;
      for (var i = 0; i < files.length; i++) {
        var file = files[i];
        getBase64(file, vue, self);
      }
    };

    this.bloquearCamposPreenchidos();

    console.log(this.formData.passoIndic);
    console.log(this.isDocPendente);
    if (this.isDocPendente) {
      this.limparCampos();
    }
    if (this.formData.passoIndic === 'PASSO_5') {
      this.limparCamposEnvioProposta();
    }
  },
};
</script>
